// pages/EditarReserva.js
import React, { useRef, useState, useEffect } from 'react';
import {
  Form,Card ,Radio ,
  Input,
  Select,
  DatePicker,
  InputNumber,
  Checkbox,
  Typography,
  Row,
  Col,
  Button,
  Space,
  Tabs,
  Badge,
  Tag,
  message,
  Affix,
  Table,
  Dropdown,
  Popconfirm,
  Tooltip,
  Modal,
  Alert,
  Divider,
  Drawer,
  List
} from 'antd';
import {
  UserOutlined,
  PhoneOutlined,
  MailOutlined,
  TeamOutlined,
  FileTextOutlined,
  SettingOutlined,
  SearchOutlined,
  CalendarOutlined,
  EyeOutlined,
  EditOutlined,
  SaveOutlined,
  CloseOutlined,
  CreditCardOutlined,
  DollarOutlined,
  PlusOutlined,
  ReloadOutlined,
  HomeOutlined,
  DeleteOutlined,CalculatorOutlined,
  ExclamationCircleOutlined,
  LoadingOutlined
} from '@ant-design/icons';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import dayjs from 'dayjs';


import PageContainer from '../components/PageContainer';
import DepositosReserva from '../components/DepositosReserva';
import CargosReserva from '../components/CargosReserva';
import AsignacionHabitacionesDrawer from '../components/AsignacionHabitacionesDrawer';
import { BASE_URL } from '../utils/constants';
import DistribucionHabitacionesModal from '../components/DistribucionHabitacionesModal';
import Facturacion from '../pages/Facturacion';

const { Title, Text } = Typography;
const { Option } = Select;
const { TabPane } = Tabs;
const { TextArea } = Input;

const EditarReserva = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  
  // Estados principales
  const [loading, setLoading] = useState(false);
  const [reserva, setReserva] = useState(null);
  const [editMode, setEditMode] = useState(!id); // Si no hay ID, es nueva reserva
  
  const [modalDistribucionVisible, setModalDistribucionVisible] = useState(false);
  const [reservaSeleccionada, setReservaSeleccionada] = useState(null);  
  
  // Estados para modales y drawers
  const [depositosModalVisible, setDepositosModalVisible] = useState(false);
  const [cargosModalVisible, setCargosModalVisible] = useState(false);

  const [facturacionModalVisible, setFacturacionModalVisible] = useState(false);  
  
  // Estados para líneas de reserva
  const [lineasReserva, setLineasReserva] = useState([]);
  const [loadingLineas, setLoadingLineas] = useState(false);
  const [lineaSeleccionadaAsignacion, setLineaSeleccionadaAsignacion] = useState(null);
  const [drawerAsignacionVisible, setDrawerAsignacionVisible] = useState(false);
  
  const [datosFiltrados, setDatosFiltrados] = useState([]);
  // Estados para datos maestros
  const [agencias, setAgencias] = useState([]);
  const [subagencias, setSubagencias] = useState([]);
  const [particulares, setParticulares] = useState([]);
  const [paises, setPaises] = useState([]);
  const [provincias, setProvincias] = useState([]);
  const [regimenes, setRegimenes] = useState([]);
  const [opciones, setOpciones] = useState([]);
  const [tiposCliente, setTiposCliente] = useState([]);
  const [politicasCancelacion, setPoliticasCancelacion] = useState([]);
  const [idiomas, setIdiomas] = useState([]);
  const [tiposComunicacion, setTiposComunicacion] = useState([]);
  const [estadosReserva, setEstadosReserva] = useState([]);
  const [series, setSeries] = useState([]);
  const [habitacionesVenta, setHabitacionesVenta] = useState([]);
  const [tiposFacturacion, setTiposFacturacion] = useState([]);

  const [habitacionesDisponibles, setHabitacionesDisponibles] = useState([]);
  const [cargandoHabitacionesDisponibles, setCargandoHabitacionesDisponibles] = useState(false);  
  const [cargandoAsignacion, setCargandoAsignacion] = useState(false);    
  const [tiposHabitacionDisponibles, setTiposHabitacionDisponibles] = useState([]);    
  const [plantasDisponibles, setPlantasDisponibles] = useState([]);
  const [mensajeDisponibilidad, setMensajeDisponibilidad] = useState('');      
  
  const [modalLineaVisible, setModalLineaVisible] = useState(false);
  const [lineaEditando, setLineaEditando] = useState(null);  
  const [modoEdicionLinea, setModoEdicionLinea] = useState('persona'); // 'persona' o 'habitacion'        
  const [formLinea] = Form.useForm();
  const [mostrarCampoEdad, setMostrarCampoEdad] = useState(false);
  const [guardandoLinea, setGuardandoLinea] = useState(false);
  const [modalBuscarParticularVisible, setModalBuscarParticularVisible] = useState(false);
  const [filtroParticular, setFiltroParticular] = useState('');
  const [particularesBusqueda, setParticularesBusqueda] = useState([]);
  const [cargandoParticulares, setCargandoParticulares] = useState(false);
  const [paginacionParticular, setPaginacionParticular] = useState({
          current: 1,
          pageSize: 10,
          total: 0
  });    

  const [mostrarServicioCocina, setMostrarServicioCocina] = useState(false);      

  const [incluirHabitacionesOcupadas, setIncluirHabitacionesOcupadas] = useState(false);          
  
    // Estados adicionales
  const [agenciaNombre, setAgenciaNombre] = useState('');
  const [subagenciaNombre, setSubagenciaNombre] = useState('');
  const [modalBusquedaVisible, setModalBusquedaVisible] = useState(false);
  const [tipoBusqueda, setTipoBusqueda] = useState('');
  const [datosBusqueda, setDatosBusqueda] = useState([]);
  const [filtroBusqueda, setFiltroBusqueda] = useState('');
  const [cargandoBusqueda, setCargandoBusqueda] = useState(false);
  const [paginacionBusqueda, setPaginacionBusqueda] = useState({
      current: 1,
      pageSize: 10,
      total: 0
  });


  const [contratos, setContratos] = useState([]);
  const [lineasContratoCargadas, setLineasContratoCargadas] = useState([]);
  const [cargandoContratos, setCargandoContratos] = useState(false);
  const [tipoPrecio, setTipoPrecio] = useState('manual'); // 'manual' o 'contrato'
  const [precioManual, setPrecioManual] = useState({
      pEspHab: '',
      pEspHabMP: '',
      pEspHabHD: '',
      pEspHabHA: '',
      pEspHabTI: '',
      pEspRegimen: '',
      suplementoIndividual: '',
      suplementoDoble: '',
      duiPrecio: '',
      duiSuplemento: false,
      reduccionAdulto1: '',
      reduccionAdulto2: '',
      suplementoAdulto1: '',
      suplementoAdulto2: '',
      reduccionEspecialAdulto: '',
      reduccionEspecialNino: '',
      reduccionesPorValorAbsoluto: false,
      codigoIVA: '1',
      ivaAplicado: 'I', // 'I' = Incluido, 'D' = Desglosado
      precioDesglosado: false,
      preciosNinos: [
          { de: '', a: '', n1: '', n2: '' },
          { de: '', a: '', n1: '', n2: '' },
          { de: '', a: '', n1: '', n2: '' }
      ]
      });
  const [contratoSeleccionado, setContratoSeleccionado] = useState(null);
  const [cargandoPrecios, setCargandoPrecios] = useState(false);
  const [tiposIVA, setTiposIVA] = useState([]);    


  const [modalImporteManualVisible, setModalImporteManualVisible] = useState(false);
  const [importeManualTotal, setImporteManualTotal] = useState('');
  const [lineasParaImporteManual, setLineasParaImporteManual] = useState([]);
  const [modalSeleccionLineaVisible, setModalSeleccionLineaVisible] = useState(false);
  const [lineaSeleccionadaImporte, setLineaSeleccionadaImporte] = useState(null);    

    // Cargar datos iniciales
  useEffect(() => {
      fetchDatosMaestros();
  
      if (id) {
          fetchReserva(id);
          setEditMode(false);
      } else {
          // Nueva reserva
          inicializarNuevaReserva();
      }
  }, [id]);

  // Efecto para calcular total de habitaciones
  useEffect(() => {
      const calcularTotalHabitaciones = () => {
      const values = form.getFieldsValue();
      const total = (values.I_ || 0) + (values.DO || 0) + (values.TR || 0) + 
                    (values.CU || 0) + (values.QU || 0);
      form.setFieldValue('Habitaciones', total);
    };

    const { I_, DO, TR, CU, QU } = form.getFieldsValue();
    calcularTotalHabitaciones();
  }, [form, form.getFieldsValue()?.I_, form.getFieldsValue()?.DO, 
      form.getFieldsValue()?.TR, form.getFieldsValue()?.CU, form.getFieldsValue()?.QU]);

  // Cargar líneas de reserva cuando hay reserva
  useEffect(() => {
      if (reserva) {
          fetchLineasReserva(reserva.NumReserva);
          fetchPreciosReserva(reserva.NumReserva);
          }
  }, [reserva]);

  useEffect(() => {
        if (contratoSeleccionado    ) {
            fetchLineasContrato(contratoSeleccionado)
        }
  }, [contratoSeleccionado]);    

  const fetchDatosMaestros = async () => {
      try {
          const token = localStorage.getItem('token');
      
          const requests = [
                axios.get(`${BASE_URL}/api/agencias`, { headers: { Authorization: `Bearer ${token}` } }),
                axios.get(`${BASE_URL}/api/subagencias`, { headers: { Authorization: `Bearer ${token}` } }),
                axios.get(`${BASE_URL}/api/particulares`, { headers: { Authorization: `Bearer ${token}` } }),
                axios.get(`${BASE_URL}/api/paises`, { headers: { Authorization: `Bearer ${token}` } }),
                axios.get(`${BASE_URL}/api/provincias`, { headers: { Authorization: `Bearer ${token}` } }),
                axios.get(`${BASE_URL}/api/tiposregimen`, { headers: { Authorization: `Bearer ${token}` } }),
                axios.get(`${BASE_URL}/api/tiposclientes`, { headers: { Authorization: `Bearer ${token}` } }),
                axios.get(`${BASE_URL}/api/cancelaciones`, { headers: { Authorization: `Bearer ${token}` } }),
                axios.get(`${BASE_URL}/api/idiomas`, { headers: { Authorization: `Bearer ${token}` } }),
                axios.get(`${BASE_URL}/api/tipos-comunicacion`, { headers: { Authorization: `Bearer ${token}` } }),
                axios.get(`${BASE_URL}/api/reservas-estados`, { headers: { Authorization: `Bearer ${token}` } }),
                axios.get(`${BASE_URL}/api/series`, { headers: { Authorization: `Bearer ${token}` } }),
                axios.get(`${BASE_URL}/api/habitacionesventa`, { headers: { Authorization: `Bearer ${token}` } }),
                axios.get(`${BASE_URL}/api/tipos-facturacion`, { headers: { Authorization: `Bearer ${token}` } }),
                axios.get(`${BASE_URL}/api/opciones/hotel`, { headers: { Authorization: `Bearer ${token}` } }),
                axios.get(`${BASE_URL}/api/contratos`, { headers: { Authorization: `Bearer ${token}` } }),
                axios.get(`${BASE_URL}/api/tiposiva`, { headers: { Authorization: `Bearer ${token}` } }),        
          ];
      
          const responses = await Promise.all(requests);
      
          setAgencias(responses[0].data.data || []);
          setSubagencias(responses[1].data.data || []);
          setParticulares(responses[2].data.data || []);
          setPaises(responses[3].data.data || []);
          setProvincias(responses[4].data.data || []);
          setRegimenes(responses[5].data.data || []);
          setTiposCliente(responses[6].data.data || []);
          setPoliticasCancelacion(responses[7].data.data || []);
          setIdiomas(responses[8].data.data || []);
          setTiposComunicacion(responses[9].data.data || []);
          setEstadosReserva(responses[10].data.data || []);
          setSeries(responses[11].data.data || []);
          setHabitacionesVenta(responses[12].data.data || []);
          setTiposFacturacion(responses[13].data.data || []);
          setOpciones(responses[14].data.data || []);
          setContratos(responses[15].data.data || []);
          setTiposIVA(responses[16].data.data || []);      
      
      } catch (error) {
          console.error('Error cargando datos maestros:', error);
          message.error('Error al cargar datos maestros');
      }
  };

  const fetchReserva = async (reservaId) => {
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(
        `${BASE_URL}/api/reservas/${reservaId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      const reservaData = response.data.data.cabecera;
      setReserva(reservaData);
      setLineasReserva(response.data.data.lineas || []);
      
      // Cargar datos en el formulario
      form.setFieldsValue({
        ...reservaData,
        Entrada: reservaData.Entrada ? dayjs(reservaData.Entrada) : null,
        Salida: reservaData.Salida ? dayjs(reservaData.Salida) : null,
        Fechareserva: reservaData.Fechareserva ? dayjs(reservaData.Fechareserva) : dayjs(),
        FechaBooking: reservaData.FechaBooking ? dayjs(reservaData.FechaBooking) : dayjs(),
        FechaUltimaModificacion: reservaData.FechaUltimaModificacion ? dayjs(reservaData.FechaUltimaModificacion) : null,
        FechaHoraProforma: reservaData.FechaHoraProforma ? dayjs(reservaData.FechaHoraProforma) : null,
      });
      
      if (reservaData.Agencia) {
        buscarAgenciaPorCodigo(reservaData.Agencia);
      }
      if (reservaData.SubAgen) {
        buscarSubagenciaPorCodigo(reservaData.SubAgen);
      }
      
    } catch (error) {
      console.error('Error cargando reserva:', error);
      message.error('Error al cargar la reserva');
      navigate('/reservas');
    } finally {
      setLoading(false);
    }
  };

  const fetchLineasContrato = async (codigoContrato) => {
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get(`${BASE_URL}/api/lincontrato/${codigoContrato}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            
            // console.log(" Lineas Contrato >= ",response.data.data);
            
            setLineasContratoCargadas(response.data.data || []);
        } catch (error) {
            console.error('❌ Error cargando lincontrato:', error);
            message.error('Error al cargar las líneas del contrato');
            setLineasContratoCargadas([]);
        }
  };

  const fetchPreciosReserva = async (reservaId) => {
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get(
                `${BASE_URL}/api/precios-reserva/${reservaId}/precios`,
                { headers: { Authorization: `Bearer ${token}` } }
            );
    
            if (response.data.data) {
                const datosPrecios = response.data.data;
      
                // Verificar si hay contrato
                if (datosPrecios.codigoContrato && datosPrecios.codigoContrato !== '') {
                    setTipoPrecio('contrato');
                    setContratoSeleccionado(datosPrecios.codigoContrato);
                } else {
                    setTipoPrecio('manual');
                    // Cargar datos de precio manual si existen
                    if (datosPrecios.manual) {
                        setPrecioManual(datosPrecios.manual);
                    }
                }
            }
        } catch (error) {
            console.error('Error cargando precios:', error);
            
        }
  };  

  const fetchLineasReserva = async (numReserva) => {
    setLoadingLineas(true);
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(
        `${BASE_URL}/api/reservas/${numReserva}/lineas`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      setLineasReserva(response.data.data || []);
    } catch (error) {
      console.error('Error obteniendo líneas:', error);
      message.error('Error al cargar las líneas de reserva');
    } finally {
      setLoadingLineas(false);
    }
  };

  const calcularTotalHabitaciones = () => {
        const lineasUnicas = [...new Set(lineasReserva.map(l => l.Linea))];
        return lineasUnicas.length;
  };

  const calcularTotalPersonas = () => {
       return lineasReserva.filter(l => !l.Anulada).length;
  };    


  const inicializarNuevaReserva = async () => {
    form.setFieldsValue({
      codparti: '0',
      Nombre: 'HUESPED',
      Nacion: 'ESPAÑA',
      Idioma: 'CAS',
      Serie: 'A',
      Facturado: false,
      Anulada: false,
      Regimen: '',
      SerEntrada: '',
      SerSalida: '',
      RegMp: '0',
      FPago: 1,
      FacturarTasa: 0,
      TipoPrecio: 'M',
      I_: 0,
      DO: 0,
      TR: 0,
      CU: 0,
      QU: 0,
      Fechareserva: dayjs(),
      FechaBooking: dayjs(),
      Entrada: dayjs(),
      Salida: dayjs().add(1, 'day'),
      esGrupoHabitaciones: false,
      ReservadeBloqueo: false,
      NoReembolsable: false,
      AplicaDtoEarlyBooking: true,
      AplicaDtoDias: true
    });
    
    obtenerUltimoNumeroReserva();
  };

  const obtenerUltimoNumeroReserva = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(
        `${BASE_URL}/api/reservas/ultimo-numero`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      form.setFieldValue('NumReserva', response.data.data.nuevoNumero);
    } catch (error) {
      console.error('Error obteniendo último número:', error);
    }
  };

  const obtenerUltimoLocalizador = async (agencia) => {
    if (!agencia) {
      message.warning('Primero seleccione una agencia');
      return;
    }
    
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(
        `${BASE_URL}/api/reservas/ultimo-localizador/${agencia}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      form.setFieldValue('SNumero', response.data.data.nuevoLocalizador);
      message.success(`Localizador generado: ${response.data.data.nuevoLocalizador}`);
    } catch (error) {
      console.error('Error obteniendo último localizador:', error);
      message.error('Error al generar localizador');
    }
  };

  const handleCambioContrato = async (codigoContrato) => {
      setContratoSeleccionado(codigoContrato);
  
      if (codigoContrato) {
          try {
              setCargandoContratos(true);
              await fetchLineasContrato(codigoContrato);
          } catch (error) {
              console.error('Error cargando líneas del contrato:', error);
          } finally {
              setCargandoContratos(false);
          }
      } else {
          setLineasContratoCargadas([]);
      }
  };

  const handleCambioTipoFacturacion = (tipo) => {
      const tiposNinos = ['NI1', 'NI2', 'NIE'];
      setMostrarCampoEdad(tiposNinos.includes(tipo));
  
      if (tiposNinos.includes(tipo)) {
          formLinea.setFieldValue('EdadNino', 0);
      } else {
          formLinea.setFieldValue('EdadNino', null);
      }
  };  

  const handleCambioRegimenLinea = (regimen) => {
      setMostrarServicioCocina(regimen === 'MP');
  
      if (regimen === 'MP') {
          formLinea.setFieldValue('ServicioCocinaMP', '0');
      } else {
          formLinea.setFieldValue('ServicioCocinaMP', null);
      }
  };    

  const handleGuardarReserva = async () => {
    try {
      setLoading(true);
      const values = await form.validateFields();
      const token = localStorage.getItem('token');
      
      const datosReserva = {
        ...values,
        Entrada: values.Entrada ? values.Entrada.startOf('day').format('YYYY-MM-DDTHH:mm:ss') : null,
        Salida: values.Salida ? values.Salida.startOf('day').format('YYYY-MM-DDTHH:mm:ss') : null,
        Fechareserva: values.Fechareserva ? values.Fechareserva.startOf('day').format('YYYY-MM-DDTHH:mm:ss') : dayjs().startOf('day').format('YYYY-MM-DDTHH:mm:ss'),
        FechaBooking: values.FechaBooking ? values.FechaBooking.startOf('day').format('YYYY-MM-DDTHH:mm:ss') : dayjs().startOf('day').format('YYYY-MM-DDTHH:mm:ss'),
        FechaUltimaModificacion: dayjs().format('YYYY-MM-DDTHH:mm:ss'),
        FechaHoraProforma: values.FechaHoraProforma ? values.FechaHoraProforma.format('YYYY-MM-DDTHH:mm:ss') : null,
      };
      
      if (reserva) {
        // Actualizar reserva existente
        const response = await axios.put(
          `${BASE_URL}/api/reservas/${reserva.NumReserva}`,
          datosReserva,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        
        message.success('Reserva actualizada correctamente');
        setReserva(response.data.data);
        setEditMode(false);
        
      } else {
        // Crear nueva reserva
        const response = await axios.post(
          `${BASE_URL}/api/reservas`,
          datosReserva,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        
        message.success('Reserva creada correctamente');
        const nuevaReservaId = response.data.data.cabecera.NumReserva;
        navigate(`/reservas/${nuevaReservaId}`);
      }
      
    } catch (error) {
      console.error('❌ Error guardando reserva:', error);
      
      if (error.response?.data?.error) {
        message.error(error.response.data.error);
      } else if (error.response?.data?.details) {
        message.error(error.response.data.details);
      } else {
        message.error('Error al guardar la reserva');
      }
    } finally {
      setLoading(false);
    }
  };

  const handleCancelarEdicion = () => {
    if (reserva) {
      // Recargar datos originales
      fetchReserva(reserva.NumReserva);
      setEditMode(false);
    } else {
      // Si es nueva reserva, volver a la lista
      navigate('/reservas');
    }
  };

  const buscarAgenciaPorCodigo = async (codigo) => {
    if (!codigo) {
      setAgenciaNombre('');
      return;
    }

    try {
      const token = localStorage.getItem('token');
      const res = await axios.get(`${BASE_URL}/api/agencias/${codigo}`, 
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setAgenciaNombre(res.data.data.Nombre);
    } catch {
      setAgenciaNombre('');
      message.warning('Agencia no encontrada');
      form.setFieldValue('Agencia', '');
    }
  };

  const buscarSubagenciaPorCodigo = async (codigo) => {
    if (!codigo) {
      setSubagenciaNombre('');
      return;
    }

    try {
      const token = localStorage.getItem('token');
      const res = await axios.get(`${BASE_URL}/api/subagencias/${codigo}`, 
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setSubagenciaNombre(res.data.data.Nombre);
    } catch {
      setSubagenciaNombre('');
      message.warning('Subagencia no encontrada');
      form.setFieldValue('SubAgen', '');
    }
  };

  const abrirModalBusqueda = (tipo) => {
      setTipoBusqueda(tipo);
      setModalBusquedaVisible(true);
      setFiltroBusqueda('');
      buscarDatos(tipo, '', 1);
  };

  const abrirDrawerAsignacion = () => {
      if (!lineaSeleccionadaAsignacion) {
          message.warning('Seleccione una línea primero');
          return;
      }
  
      if (lineaSeleccionadaAsignacion.NFactura > 0) {
          message.error('No se puede asignar habitación a una línea facturada');
          return;
      }

      // console.log(" lineaSeleccionadaAsignacion => ",lineaSeleccionadaAsignacion);  
  
      setDrawerAsignacionVisible(true);
      cargarHabitacionesDisponibles(lineaSeleccionadaAsignacion);
  };

  const timeoutRef = useRef(null);

  const handleBuscarChange = (e) => {
        const value = e.target.value;
        setFiltroBusqueda(value);

        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        timeoutRef.current = setTimeout(() => {
            buscarDatos(tipoBusqueda, value, 1);
        }, 400);
  };    


  const handleBuscarLocal = (e) => {
      const value = e.target.value.toLowerCase();
      setFiltroBusqueda(value);

      const filtrados = datosBusqueda.filter(item =>
          item.Codigo?.toLowerCase().includes(value) ||
          item.Nombre?.toLowerCase().includes(value)
      );

      setDatosFiltrados(filtrados);
  };


  const buscarDatos = async (tipo, filtro = '', pagina = 1) => {
    setCargandoBusqueda(true);
    try {
      const token = localStorage.getItem('token');
      let url = '';
      
      const queryParams = new URLSearchParams({
        page: pagina,
        pageSize: paginacionBusqueda.pageSize,
        ...(filtro && { search: filtro })
      });

      switch(tipo) {
        case 'agencia':
          url = `${BASE_URL}/api/agencias?${queryParams.toString()}`;
          break;
        case 'subagencia':
          url = `${BASE_URL}/api/subagencias?${queryParams.toString()}`;
          break;
        case 'particular':
          url = `${BASE_URL}/api/particulares?${queryParams.toString()}`;
          break;
        default:
          return;
      }

      const response = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` }
      });

      setDatosBusqueda(response.data.data || []);
      setDatosFiltrados(response.data.data || []);
      setPaginacionBusqueda(prev => ({
        ...prev,
        current: pagina,
        total: response.data.pagination?.total || 0
      }));
    } catch (error) {
      console.error('Error buscando datos:', error);
      message.error('Error al buscar datos');
    } finally {
      setCargandoBusqueda(false);
    }
  };

  const seleccionarElemento = (elemento) => {
    switch (tipoBusqueda) {
      case 'agencia':
        form.setFieldValue('Agencia', elemento.Codigo);
        buscarAgenciaPorCodigo(elemento.Codigo);
        
        if (elemento.enFactura){
          form.setFieldValue("FacturarTasa",1)
        } else {
          form.setFieldValue("FacturarTasa",0)
        }

        if (elemento.credito){
          form.setFieldValue("FPago",0)
        } else {
          form.setFieldValue("FPago",1)
        }
        break;

      case 'subagencia':
        form.setFieldsValue({SubAgen: elemento.Codigo});
        buscarSubagenciaPorCodigo(elemento.Codigo);
        break;

      case 'particular':
        form.setFieldsValue({
          codparti: elemento.Codigo,
          Nombre: elemento.Nombre || 'HUESPED',
          Telefono: elemento.Telefono || '',
          CorreoElectronico: elemento.Email || '',
          Nacion: elemento.Pais || 'ESPAÑA'
        });
        form.setFieldValue('CodParti', elemento.Codigo);
        break;
    }

    setModalBusquedaVisible(false);
  };

  const actualizarServiciosPorRegimen = (regimenCodigo) => {
    const regimenSeleccionado = regimenes.find(r => r.Codigo === regimenCodigo);
    
    if (!regimenSeleccionado) return;
    
    const serEntradaActual = form.getFieldValue('SerEntrada');
    const serSalidaActual = form.getFieldValue('SerSalida');
    
    if (!serEntradaActual && regimenSeleccionado.SerEntrada && regimenSeleccionado.SerEntrada.trim() !== '') {
      form.setFieldValue('SerEntrada', regimenSeleccionado.SerEntrada);
    }
    
    if (!serSalidaActual && regimenSeleccionado.SerSalida && regimenSeleccionado.SerSalida.trim() !== '') {
      form.setFieldValue('SerSalida', regimenSeleccionado.SerSalida);
    }
    
    if (regimenCodigo === 'MP') {
      form.setFieldValue('RegMp', '0');
    }
  };

  const calcularProximaLinea = () => {
      if (lineasReserva.length === 0) return 1;
  
      const maxLinea = Math.max(...lineasReserva.map(l => l.Linea));
      return maxLinea + 1;
  };

  const añadirHabitacionAutomatica = async (tipoHab) => {
      try {
          setLoadingLineas(true);
  
          // Verificar que tenemos una reserva activa
          if (!reserva) {
              message.error('No hay reserva seleccionada');
              return;
          }
            
          // Calcular el próximo número de línea
          const proximaLinea = calcularProximaLinea();
    
          // Obtener datos de la cabecera para usar como valores por defecto
          const datosCabecera = {
                Agencia: reserva.Agencia || '',
                SubAgencia: reserva.SubAgen || '',
                Nombre: reserva.Nombre || 'HUESPED',
                SNumero: reserva.SNumero || '',
                Entrada: reserva.Entrada || '',
                Salida: reserva.Salida || '',
                Regimen: reserva.Regimen || 'PC',
                SerEntrada: reserva.SerEntrada || '',
                SerSalida: reserva.SerSalida || '',
                RegMp: reserva.RegMp || '0',
                Serie: reserva.Serie || 'A',
                Nacion: reserva.Nacion || 'ESPAÑA',
                CodParti: reserva.codparti || '0',
                Telefono: reserva.Telefono || '',
                CorreoElectronico: reserva.CorreoElectronico || '',
                TipoCliente: reserva.TipoCliente || 'RECE',
                Provincia: reserva.Provincia || '',
                HabitacionEspecial: reserva.HabitacionEspecial || '',
                TurnoComedor: reserva.TurnoComedor || 1,
          };
    
          // Determinar número de ocupantes según el tipo de habitación
          const ocupantesPorTipo = {
                'IN': 1,
                'DO': 2,
                'TR': 3,
                'CU': 4,
                'QU': 5
          };
    
          const numOcupantes = ocupantesPorTipo[tipoHab] || 1;
    
          // Obtener configuración de reducción para determinar tipos de facturación
          const reduccion = opciones[0]?.reduccion || 'A'; // 'A' para adulto, otra para niño
    
          // Crear las líneas para esta habitación
          const lineasParaCrear = [];
    
          for (let numOcupante = 1; numOcupante <= numOcupantes; numOcupante++) {
                let tipoFac = 'DO'; // Por defecto
      
                if (tipoHab === 'IN') {
                    tipoFac = 'IN';
                } else if (numOcupante === 1) {
                    tipoFac = tipoHab === 'IN' ? 'IN' : 'DO';
                } else if (numOcupante === 2 && tipoHab !== 'IN') {
                    tipoFac = 'DO';
                } else if (numOcupante === 3) {
                    tipoFac = (reduccion === 'A') ? 'AD1' : 'NI1';
                } else if (numOcupante === 4 || numOcupante === 5) {
                    tipoFac = (reduccion === 'A') ? 'AD2' : 'NI2';
                }
      
                const lineaData = {
                    ...datosCabecera,
                    NumReserva: reserva.NumReserva,
                    Linea: proximaLinea,
                    TipoHab: tipoHab,
                    TipoFac: tipoFac,
                    Numocupante: numOcupante,
                    PEspecial: 0,
                    LPContrato: false,
                    Entro: false,
                    Salio: false,
                    Colocacion: 'FC',
                    Anulada: false,
                    TipoProduccion: 0,
                    tipoTarjeta: 1,
                    PasadaAOcupacion: false,
                    HabDiurna: false,
                    HabitacionesCompartidas: false,
                    esVip: false,
                    PrecioPorHabitacion: true,
                    calculoprecio: false,
                    CodigoContrato: '',
                    AceptaCargosTPV: false,
                    TieneWifi: false,
                    ImporteLinea: 0,
                    Contrato: datosCabecera.PContrato || '',
                    PreReserva: datosCabecera.PreReserva || false
                };
      
                lineasParaCrear.push(lineaData);
          }
    
          // Llamar al API para crear las líneas
          const token = localStorage.getItem('token');
          const response = await axios.post(
                `${BASE_URL}/api/reservas/${reserva.NumReserva}/habitaciones`,
                    {
                        tipoHab: tipoHab,
                        lineas: lineasParaCrear
                    },
                    { headers: { Authorization: `Bearer ${token}` } }
          );
    
          message.success(`Habitación ${tipoHab} añadida correctamente`);
    
          // Recargar las líneas
          fetchLineasReserva(reserva.NumReserva);
    
      } catch (error) {
          console.error('Error añadiendo habitación:', error);
          message.error(error.response?.data?.error || 'Error al añadir la habitación');
      } finally {
          setLoadingLineas(false);
      }
  };

  // Funciones para líneas de reserva (similar a las originales)
  const agruparLineasPorHabitacion = () => {
    if (!lineasReserva || lineasReserva.length === 0) return [];
    
    const lineasAgrupadas = [];
    const lineasOrdenadas = [...lineasReserva].sort((a, b) => {
      if (a.Linea === b.Linea) {
        return a.Numocupante - b.Numocupante;
      }
      return a.Linea - b.Linea;
    });
    
    lineasOrdenadas.forEach((linea) => {
      lineasAgrupadas.push({
        ...linea,
        esPrimerOcupante: linea.Numocupante === 1
      });
    });
    
    return lineasAgrupadas;
  };

  const renderizarNumeroLinea = (text, record) => {
      // Si es el primer ocupante, mostrar el número de línea en negrita
      if (record.Numocupante === 1) {
          return (
              <div style={{ fontWeight: 600, color: '#1890ff' }}>
                  {text}
              </div>
          );
      }
      return text;
  };

  const renderizarOcupante = (text, record) => {
      return (
          <div style={{ 
                      fontWeight: record.Numocupante === 1 ? 500 : 400,
                      color: record.Numocupante === 1 ? '#333' : '#666'
              }}
          >
              {text}
          </div>
      );
  };    

  const editarPersona = (record) => {
      setLineaEditando(record);
      setModoEdicionLinea('persona');
      setModalLineaVisible(true);
  
      formLinea.setFieldsValue({
          ...record,
          Entrada: record.Entrada ? dayjs(record.Entrada) : null,
          Salida: record.Salida ? dayjs(record.Salida) : null,
      });
  
      handleCambioTipoFacturacion(record.TipoFac);
      handleCambioRegimenLinea(record.Regimen);
  };    

  const editarHabitacion = (record) => {
      // Encontrar todas las líneas de esta habitación
      const lineasHabitacion = lineasReserva.filter(l => l.Linea === record.Linea);
      const primeraLinea = lineasHabitacion[0];
  
      setLineaEditando(primeraLinea);
      setModoEdicionLinea('habitacion');
      setModalLineaVisible(true);

      formLinea.setFieldsValue({
          ...primeraLinea,
          Entrada: primeraLinea.Entrada ? dayjs(primeraLinea.Entrada) : null,
          Salida: primeraLinea.Salida ? dayjs(primeraLinea.Salida) : null,
          Observacion: '', // Esto se cargará desde la tabla de observaciones
      });

      handleCambioRegimenLinea(primeraLinea.Regimen);

      // Cargar observación si existe
      cargarObservacionLinea(primeraLinea.NumReserva, primeraLinea.Linea, primeraLinea.Numocupante);
  };    

  const cargarObservacionLinea = async (numReserva, linea, ocupante) => {
      try {
          const token = localStorage.getItem('token');
          const response = await axios.get(
              `${BASE_URL}/api/observaciones-habitacion?numreserva=${numReserva}&numhabitacion=${linea}&ocupante=${ocupante}`,
                  { headers: { Authorization: `Bearer ${token}` } }
          );
  
          if (response.data.data && response.data.data.length > 0) {
              formLinea.setFieldValue('Observacion', response.data.data[0].observacion);
          }
      } catch (error) {
          console.error('Error cargando observación:', error);
      }
  };    

  const eliminarHabitacion = async (record) => {
      try {
          const token = localStorage.getItem('token');
  
          await axios.delete(
              `${BASE_URL}/api/reservas/${reserva.NumReserva}/lineas/${record.Linea}`,      
                  { headers: { Authorization: `Bearer ${token}` } }
          );
  
          message.success('Línea eliminada correctamente');
          fetchLineasReserva(reserva.NumReserva);
  
      } catch (error) {
          console.error('Error eliminando línea:', error);
          message.error(error.response?.data?.error || 'Error al eliminar la línea');
      }
  };

  const desasignarHabitacion = async () => {
      if (!lineaSeleccionadaAsignacion || !reserva) return;

      setCargandoAsignacion(true);
      try {
          const token = localStorage.getItem('token');
  
          const response = await axios.put(
              `${BASE_URL}/api/reservas/${reserva.NumReserva}/desasignar-habitacion`,
              {
                  linea: lineaSeleccionadaAsignacion.Linea,
                  aplicarATodaHabitacion: true
              },
              { headers: { Authorization: `Bearer ${token}` } }
          );
  
          if (response.data.success) {
              message.success('Habitación desasignada correctamente');
    
              // Actualizar la línea seleccionada
              setLineaSeleccionadaAsignacion(prev => ({
                  ...prev,
                  NumHab: null
              }));
    
              // Recargar las líneas
              fetchLineasReserva(reserva.NumReserva);
    
              // Recargar habitaciones disponibles (pero NO buscar siguiente)
              // porque al desasignar probablemente queremos asignar otra habitación
              cargarHabitacionesDisponibles(lineaSeleccionadaAsignacion);
          }
      } catch (error) {
          console.error('Error desasignando habitación:', error);
          message.error(error.response?.data?.error || 'Error al desasignar la habitación');
      } finally {
          setCargandoAsignacion(false);
      }
  };

  const asignarHabitacion = async (numHabitacion) => {
      if (!lineaSeleccionadaAsignacion || !reserva) return;

      setCargandoAsignacion(true);
      try {
          const token = localStorage.getItem('token');
  
          // Verificación rápida: ¿Está ya asignada esta habitación?
          const habitacionYaAsignada = lineasReserva.some(l => 
              l.NumHab === numHabitacion && 
              l.Linea !== lineaSeleccionadaAsignacion.Linea
          );
  
          if (habitacionYaAsignada) {
              message.warning(`La habitación ${numHabitacion} ya está asignada a otra línea`);
              return;
          }
  
          const response = await axios.put(
              `${BASE_URL}/api/reservas/${reserva.NumReserva}/asignar-habitacion`,
              {
                  linea: lineaSeleccionadaAsignacion.Linea,
                  numHabitacion: numHabitacion,
                  aplicarATodaHabitacion: true
              },
              { headers: { Authorization: `Bearer ${token}` } }
          );
  
          if (response.data.success) {
              // Feedback visual inmediato
              message.success({
                  content: `✅ Habitación ${numHabitacion} asignada`,
                  duration: 1,
              });
    
              // Actualizar localmente para feedback inmediato
              const lineasActualizadas = lineasReserva.map(l => {
                  if (l.Linea === lineaSeleccionadaAsignacion.Linea) {
                      return { ...l, NumHab: numHabitacion };
                  }
                  return l;
              });
    
              setLineasReserva(lineasActualizadas);
    
              // Actualizar la línea seleccionada
              setLineaSeleccionadaAsignacion(prev => ({
                  ...prev,
                  NumHab: numHabitacion
              }));
    
              // Recargar habitaciones disponibles (más rápido)
              setTimeout(() => {
                  cargarHabitacionesDisponibles(lineaSeleccionadaAsignacion);
              }, 300);
          }
      } catch (error) {
          console.error('Error asignando habitación:', error);
          message.error(error.response?.data?.error || 'Error al asignar la habitación');
      } finally {
          setCargandoAsignacion(false);
      }
  };    

  const handleGuardarPrecios = async () => {
      try {
          setCargandoPrecios(true);
  
          const token = localStorage.getItem('token');
  
          const datosPrecios = {
              tipoPrecio,
              contrato: tipoPrecio === 'contrato' ? contratoSeleccionado : null,
              manual: tipoPrecio === 'manual' ? precioManual : null
          };
  
          const response = await axios.put(
              `${BASE_URL}/api/precios-reserva/${reserva.NumReserva}/precios`,
                  datosPrecios,
              { headers: { Authorization: `Bearer ${token}` } }
          );
  
          message.success('Precios guardados correctamente');
  
      } catch (error) {
          console.error('Error guardando precios:', error);
          message.error(error.response?.data?.error || 'Error al guardar precios');
      } finally {
          setCargandoPrecios(false);
      }
  };

  const handleCalcularImporteManual = async () => {
      try {
          setCargandoPrecios(true);
  
          const token = localStorage.getItem('token');
  
          // Primero, obtener las líneas disponibles
          const response = await axios.post(
              `${BASE_URL}/api/precios-reserva/${reserva.NumReserva}/importe-manual-total`,
              {
                  importeTotal: 0, // Solo para verificar
                  lineaSeleccionada: null
              },
              { headers: { Authorization: `Bearer ${token}` } }
          );
  
          if (response.data.necesitaSeleccion) {
              // Mostrar modal para seleccionar línea
              setLineasParaImporteManual(response.data.lineas);
              setModalSeleccionLineaVisible(true);
          } else {
              // Solo hay una línea, mostrar modal de importe
              setLineaSeleccionadaImporte(response.data.datos?.linea || null);
              setModalImporteManualVisible(true);
          }
  
      } catch (error) {
          console.error('Error iniciando importe manual:', error);
  
          if (error.response?.data?.success === false && !error.response.data.necesitaSeleccion) {
              message.error(error.response.data.error || 'Error al calcular importe manual');
          }
      } finally {
          setCargandoPrecios(false);
      }
  };

  const handleSeleccionarLineaImporte = (linea) => {
      setLineaSeleccionadaImporte(linea);
      setModalSeleccionLineaVisible(false);
      setModalImporteManualVisible(true);
  };

  const handleConfirmarImporteManual = async () => {
      if (!importeManualTotal || isNaN(parseFloat(importeManualTotal))) {
          message.warning('Por favor, ingrese un importe válido');
          return;
      }

      try {
          setCargandoPrecios(true);
  
          const token = localStorage.getItem('token');
          const importe = parseFloat(importeManualTotal);
  
          // Verificar si la línea tiene precio especial
          const checkPrecioResponse = await axios.get(
              `${BASE_URL}/api/precios-reserva/${reserva.NumReserva}/lineas/${lineaSeleccionadaImporte}/precio-especial`,
                  { headers: { Authorization: `Bearer ${token}` } }
          );
  
          let tienePrecioEspecial = false;
          if (checkPrecioResponse.data.success) {
              tienePrecioEspecial = checkPrecioResponse.data.tienePrecioEspecial;
          }
  
          // Si tiene precio especial, pedir confirmación
          if (tienePrecioEspecial) {
              Modal.confirm({
                  title: '⚠️ ¡ATENCIÓN!',
                  content: 'Esta reserva ya tiene precio especial asignado. Si continúa, se perderá el precio actual. ¿Desea continuar?',
                  okText: 'Continuar',
                  okType: 'danger',
                  cancelText: 'Cancelar',
                  onOk: () => aplicarImporteManual(importe),
              });
          } else {
              aplicarImporteManual(importe);
          }
  
      } catch (error) {
          console.error('Error confirmando importe manual:', error);
          message.error('Error al procesar la solicitud');
      } finally {
          setCargandoPrecios(false);
      }
  };

  const aplicarImporteManual = async (importe) => {
      try {
          const token = localStorage.getItem('token');
  
          const response = await axios.post(
              `${BASE_URL}/api/precios-reserva/${reserva.NumReserva}/importe-manual-total`,
              {
                  importeTotal: importe,
                  lineaSeleccionada: lineaSeleccionadaImporte
              },
              { headers: { Authorization: `Bearer ${token}` } }
          );
  
          if (response.data.success) {
              message.success(response.data.message);
    
              // Cerrar modales y resetear
              setModalImporteManualVisible(false);
              setImporteManualTotal('');
              setLineaSeleccionadaImporte(null);
    
              // Recargar datos
              fetchReserva(reserva.NumReserva);
              fetchLineasReserva(reserva.NumReserva);
          }
          
      } catch (error) {
          console.error('Error aplicando importe manual:', error);
  
          if (error.response?.data?.error) {
              message.error(error.response.data.error);
    
              if (error.response.data.detalles) {
                  console.log('Detalles:', error.response.data.detalles);
              }
          } else {
              message.error('Error al aplicar el importe manual');
          }
      }
  };

  const handleCambioPrecioNino = (index, campo, valor) => {
      const nuevosPrecios = [...precioManual.preciosNinos];
      nuevosPrecios[index] = {
          ...nuevosPrecios[index],
          [campo]: valor
      };

      setPrecioManual({
          ...precioManual,
          preciosNinos: nuevosPrecios
      });
  };    

  const cerrarDrawerAsignacion = () => {
      setDrawerAsignacionVisible(false);
      // No limpiamos la línea seleccionada para poder seguir trabajando
  };    

  const guardarCambiosLinea = async () => {
      try {
          setGuardandoLinea(true);
          const valores = await formLinea.validateFields();
  
          // Verificar si está facturada
          if (lineaEditando?.NFactura > 0) {
              message.error('No se puede modificar una línea facturada');
              return;
          }
  
          const token = localStorage.getItem('token');
  
          if (modoEdicionLinea === 'persona') {
              // Actualizar solo una persona
    
    
              const datosPersona = {
                  ...valores,
                  Entrada: valores.Entrada ? valores.Entrada.format('YYYY-MM-DD') : null,
                  Salida: valores.Salida ? valores.Salida.format('YYYY-MM-DD') : null,
                  RegMp: valores.ServicioCocinaMP || '0'
              };
    
              // Si hay EdadNino, convertir a número
              if (datosPersona.EdadNino) {
                  datosPersona.EdadNino = parseInt(datosPersona.EdadNino);
              }
    
              // Guardar cambios en la persona
              await axios.put(
                  `${BASE_URL}/api/reservas/${reserva.NumReserva}/lineas/${lineaEditando?.Linea}/ocupantes/${lineaEditando?.Numocupante}`,
                  datosPersona,
                  { headers: { Authorization: `Bearer ${token}` } }
              );
    
              // Guardar observación si existe
              if (valores.Observacion) {
                  await guardarObservacion(valores.Observacion, lineaEditando?.Linea, lineaEditando?.Numocupante);
              }
    
              message.success('Persona actualizada correctamente');
    
          } else {
              // console.log(" Entrada , Salida => ",valores.Entrada,valores.Salida);

              // Actualizar habitación completa
              const datosHabitacion = {
                  ...valores,
                  Entrada: valores.Entrada ? valores.Entrada.format('YYYY-MM-DD') : null,
                  Salida: valores.Salida ? valores.Salida.format('YYYY-MM-DD') : null,
                  NumHab: valores.NumHab || null,
                  RegMp: valores.ServicioCocinaMP || '0'
              };
    

              // console.log(" datosHabitacion >= ",datosHabitacion);
    
              // Actualizar todas las líneas de esta habitación
              await axios.put(
                  `${BASE_URL}/api/reservas/${reserva.NumReserva}/habitaciones/${lineaEditando?.Linea}`,
                  datosHabitacion,
                  { headers: { Authorization: `Bearer ${token}` } }
              );
    
              // Guardar observación para cada ocupante
              if (valores.Observacion) {
                  // Obtener todas las personas de esta habitación
                  const lineasHabitacion = lineasReserva.filter(l => l.Linea === lineaEditando?.Linea);
                  for (const linea of lineasHabitacion) {
                      await guardarObservacion(valores.Observacion, linea.Linea, linea.Numocupante);
                  }
              }
    
              message.success('Habitación actualizada correctamente');
          }
  
          // Recargar datos
          fetchLineasReserva(reserva.NumReserva);
          cerrarModalLinea();
  
      } catch (error) {
          console.error('Error guardando línea:', error);
  
          if (error.response?.data?.error) {
              message.error(error.response.data.error);
          } else if (error.response?.data?.details) {
              message.error(error.response.data.details);
          } else {
              message.error('Error al guardar los cambios');
          }
      } finally {
          setGuardandoLinea(false);
      }
  };    

  const getLineasPrimerOcupante = () => {
      if (!lineasReserva || lineasReserva.length === 0) return [];
  
      return lineasReserva
              .filter(linea => linea.Numocupante === 1)
              .map(linea => ({
                  linea: linea.Linea,
                  nombre: linea.Nombre || 'Sin nombre',
                  tipoHab: linea.TipoHab,
                  numHabitacion: linea.NumHab || 'Sin asignar'
              }));
  };    

  const guardarObservacion = async (observacion, numHabitacion, ocupante) => {
      try {
          const token = localStorage.getItem('token');
          const datosObservacion = {
              numreserva: reserva.NumReserva,
              numhabitacion: numHabitacion,
              ocupante: ocupante,
              observacion: observacion
          };
  
          await axios.post(
              `${BASE_URL}/api/observaciones-habitacion`,
              datosObservacion,
              { headers: { Authorization: `Bearer ${token}` } }
          );
      } catch (error) {
          console.error('Error guardando observación:', error);
      }
  };    

  const cerrarModalLinea = () => {
      setModalLineaVisible(false);
      setLineaEditando(null);
      formLinea.resetFields();
      setMensajeDisponibilidad('');
  };


  const cargarHabitacionesDisponibles = async (linea) => {

      if (!linea || !reserva) return;

      setCargandoHabitacionesDisponibles(true);
      try {
          const token = localStorage.getItem('token');
          const entrada = dayjs(linea.Entrada).format('YYYY-MM-DD');
          const salida = dayjs(linea.Salida).format('YYYY-MM-DD');
  
          // Construir URL con parámetros
          const params = new URLSearchParams({
              entrada: entrada,
              salida: salida,
              excluirReserva: reserva.NumReserva,
              incluirOcupadas: incluirHabitacionesOcupadas
          });
  
          // Añadir tipo de habitación si queremos filtrar por el tipo de la línea
          // Podemos usar el TipoHab de la línea para filtrar habitaciones compatibles
          if (linea.TipoHab) {
              // Mapear tipo de habitación de línea a tipo de habitación de la tabla
              const mapaTipos = {
                  'IN': 'INDIVIDUAL',
                  'DO': 'DOBLE', 
                  'TR': 'TRIPLE',
                  'CU': 'CUADRUPLE',
                  'QU': 'QUINTUPLE'
              };
    
              const tipoHabFiltro = mapaTipos[linea.TipoHab] || linea.TipoHab;
              params.append('tipoHab', tipoHabFiltro);
          }
          // console.log(" token  => ",token);
  
          const url = `${BASE_URL}/api/reservas/disponibles/habitaciones?${params.toString()}`;
  
          const response = await axios.get(url, {
              headers: { Authorization: `Bearer ${token}` }
          });
  
          if (response.data.success) {
              const habitaciones = response.data.data || [];
    
              // Si estamos incluyendo ocupadas, filtramos para mostrar
              let habitacionesParaMostrar = habitaciones;
    
              if (incluirHabitacionesOcupadas) {
                  // Mostramos todas pero marcamos cuáles están disponibles
                  habitacionesParaMostrar = habitaciones.map(h => ({
                      ...h,
                      numhabitacio: h.numhab || h.numhabitacio,
                      tipo: h.descrip || h.tipo || 'Standard',
                      planta: h.planta || Math.floor((h.numhab || h.numhabitacio) / 100),
                      disponible: h.disponible !== false // Por defecto true si no está definido
                  }));
              } else {
                  // Solo las disponibles
                  habitacionesParaMostrar = habitaciones
                      .filter(h => h.disponible !== false)
                      .map(h => ({
                          ...h,
                          numhabitacio: h.numhab || h.numhabitacio,
                          tipo: h.descrip || h.tipo || 'Standard',
                          planta: h.planta || Math.floor((h.numhab || h.numhabitacio) / 100)
                  }));
              }
    
              // console.log(" habitacionesParaMostrar => ",habitacionesParaMostrar);
    
              setHabitacionesDisponibles(habitacionesParaMostrar);
    
              // Extraer plantas únicas
              const plantas = [...new Set(habitacionesParaMostrar.map(h => 
                  h.planta || Math.floor((h.numhab || h.numhabitacio) / 100)
              ))].sort((a, b) => a - b);
    
              setPlantasDisponibles(plantas);
    
              // Extraer tipos únicos
              const tipos = [...new Set(habitacionesParaMostrar.map(h => 
                  h.descrip || h.tipo || 'Standard'
              ).filter(Boolean))].sort();
    
              setTiposHabitacionDisponibles(tipos);
    
              // console.log(`📊 Habitaciones cargadas: ${habitacionesParaMostrar.length} (${habitacionesParaMostrar.filter(h => h.disponible !== false).length} disponibles)`);
          }
      } catch (error) {
          console.error('Error cargando habitaciones disponibles:', error);
          message.error('Error al cargar habitaciones disponibles');
  
          // Mostrar error específico si existe
          if (error.response?.data?.error) {
              message.error(`Error: ${error.response.data.error}`);
          }
      } finally {
          setCargandoHabitacionesDisponibles(false);
      }
  };

  const abrirDistribucion = (numReserva) => {
      setReservaSeleccionada(numReserva);
      setModalDistribucionVisible(true);
  };    

  const ADULT_PRICES = [
      'preciopc', 'preciomp', 'preciohd', 'precioha', 'Precioti',
      'preciodo', 'PrecioIn'
  ];

  const CHILD_PRICES = [
      'preciode1', 'precioha1','precion11', 'precion12',
      'preciode2', 'precioha2','precion21', 'precion22',
      'preciode3', 'precioha3','precion31', 'precion32',
  ];

  const CONDITIONS = [
      'MinNoches', 'DobleUsoIndividual', 'DUISuplemento',
      'SuplCortEstanc', 'SuplCortEstancP',
      'esweekend', 'PrecioINPorcentaje', 'DUIPorcentaje'
  ];    

  const renderBlock = (title, items, record) => {
      const visibles = items.filter(
          k => record[k] !== 0 && record[k] !== null && record[k] !== undefined
      );

      if (!visibles.length) return null;

      return (
          <div style={{ marginBottom: 8 }}>
              <b>{title}</b>
              {visibles.map(key => (
                  <div key={key}>
                      {key}:
                      {typeof record[key] === 'boolean' ? record[key] ? ' Sí' : ' No'
                          : ` ${record[key]}${typeof record[key] === 'number' ? ' €' : ''}`}
                  </div>
              ))}
          </div>
      );
  };


const handleMarcarIndividual = async (reserva) => {
  // Mostrar confirmación primero
  Modal.confirm({
    title: 'Confirmar acción',
    icon: <ExclamationCircleOutlined />,
    content: (
      <div>
        <p>¿Estás seguro de marcar esta reserva como descargada?</p>
        {/* <p><strong>Reserva:</strong> {reserva.SNumero}</p>
        <p><strong>Hotel:</strong> {reserva.CodigoHotel}</p> */}
      </div>
    ),
    okText: 'Sí, marcar',
    cancelText: 'Cancelar',
    onOk: async () => {
      try {
        const token = localStorage.getItem('token');
        
        const response = await axios({
          method: 'post',
          url: `${BASE_URL}/api/integraciones/marcar-descargada`,
          headers: { 
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
          data: {
            locationNumber: reserva.SNumero,
            hotelCode: reserva.CodigoHotel,
            agenciaXML: reserva.AgenciaXML || 'KEYTEL'
          },
          withCredentials: false
        });

        if (response.data.success) {
          message.success(`Reserva ${reserva.SNumero} marcada correctamente`);
        } else {
          message.error(response.data.error || 'Error al marcar la reserva');
        }
      } catch (error) {
        console.error('Error completo:', error);
        if (error.response?.status === 431) {
          message.error('Error: Cabeceras demasiado grandes. Probando método alternativo...');
          await handleMarcarIndividualAlternativo(reserva);
        } else {
          message.error('Error al marcar la reserva');
        }
      }
    }
  });
};

  const PriceBlock = ({ title, startDate, endDate, firstChild, secondChild }) => (
      <div style={{ 
          fontSize: '12px', 
          marginBottom: 8,
          padding: 8,
          backgroundColor: '#f8f9fa',
          borderRadius: 4
      }}>
          <div style={{ fontWeight: 500, marginBottom: 4 }}>
              {title}
          </div>
          <div style={{ fontSize: '11px', color: '#666' }}>
              <div>
                  <b>De:</b> {startDate || 'N/A'} 
                  <b> a:</b> {endDate || 'N/A'}
              </div>
              <div>
                  <b>1er. Niño:</b> {firstChild || 'N/A'}
              </div>
              <div>
                  <b>2do. Niño:</b> {secondChild || 'N/A'}
              </div>
          </div>
      </div>
  );    

  const getColumnasLineasConAcciones = () => {
    const baseColumns = [
      {
        title: 'Línea',
        dataIndex: 'Linea',
        key: 'Linea',
        width: 80,
        render: renderizarNumeroLinea,
      },
      {
        title: 'Ocupante',
        dataIndex: 'Numocupante',
        key: 'Numocupante',
        width: 80,
        render: renderizarOcupante,
      },
      {
        title: 'Nº Hab.',
        dataIndex: 'NumHab',
        key: 'NumHab',
        width: 80,
        render: (num) => num || '-',
      },    
      {
        title: 'Tipo Hab.',
        dataIndex: 'TipoHab',
        key: 'TipoHab',
        width: 100,
        render: (tipo) => {
          const tipos = {
            'IN': { color: 'blue', text: 'Individual' },
            'DO': { color: 'green', text: 'Doble' },
            'TR': { color: 'orange', text: 'Triple' },
            'CU': { color: 'purple', text: 'Cuádruple' },
            'QU': { color: 'red', text: 'Quintuple' }
          };
          const tipoInfo = tipos[tipo] || { color: 'default', text: tipo };
          return <Tag color={tipoInfo.color}>{tipoInfo.text}</Tag>;
        },
      },
      {
        title: 'Nombre',
        dataIndex: 'Nombre',
        key: 'Nombre',
        width: 200,
        editable: true,
      },
      {
        title: 'Localizador',
        dataIndex: 'SNumero',
        key: 'SNumero',
        width: 120,
      },
      {
        title: 'Estado',
        key: 'Estado',
        width: 100,
        render: (_, record) => {
          let estado = 'Pendiente';
          let color = 'default';
          
          if (record.Anulada === 1) {
            estado = 'Anulada';
            color = 'red';
          } else if (record.Entro === 1 && record.Salio === 1) {
            estado = 'Completada';
            color = 'green';
          } else if (record.Entro === 1) {
            estado = 'En curso';
            color = 'blue';
          } else if (record.NFactura > 0) {
            estado = 'Facturada';
            color = 'orange';
          }
        
          return <Tag color={color}>{estado}</Tag>;
        },
      },
      {
        title: 'Entrada',
        dataIndex: 'Entrada',
        key: 'Entrada',
        width: 120,
        render: (fecha) => fecha ? dayjs(fecha).format('DD/MM/YYYY') : '-',
      },
      {
        title: 'Salida',
        dataIndex: 'Salida',
        key: 'Salida',
        width: 120,
        render: (fecha) => fecha ? dayjs(fecha).format('DD/MM/YYYY') : '-',
      },
      {
        title: 'Tipo Fac.',
        dataIndex: 'TipoFac',
        key: 'TipoFac',
        width: 100,
      },
      {
        title: 'Regimen',
        dataIndex: 'Regimen',
        key: 'Regimen',
        width: 60,
      },
      {
        title: 'Ser. entrada',
        dataIndex: 'SerEntrada',
        key: 'SerEntrada',
        width: 60,
      },
      {
        title: 'Ser. salida',
        dataIndex: 'SerSalida',
        key: 'SerSalida',
        width: 60,
      },        
    ];
  
    baseColumns.push({
      title: 'Acciones',
      key: 'acciones',
      width: 150,
      render: (_, record) => {
        const estaFacturada = record.NFactura > 0;
        
        return (
          <Space>
            <Tooltip title="Editar Persona">
              <Button
                type="link"
                icon={<UserOutlined />}
                size="small"
                onClick={() => editarPersona(record)}
                disabled={estaFacturada}
              />
            </Tooltip>
            
            <Tooltip title="Editar Habitación">
              <Button
                type="link"
                icon={<HomeOutlined />}
                size="small"
                onClick={() => editarHabitacion(record)}
                disabled={estaFacturada}
              />
            </Tooltip>
            
            {!estaFacturada && (
                <Tooltip title="Eliminar">
                    {/* <Popconfirm
                        title="¿Eliminar esta habitación?"
                        description="Esta acción no se puede deshacer"
                        onConfirm={() => eliminarHabitacion(record)}
                        okText="Sí"
                        cancelText="No"
                        okButtonProps={{ danger: true }}
                        trigger="click" 
                    >
                        <Button
                            danger
                            icon={<DeleteOutlined />}
                            size="small"
                        />
                    </Popconfirm> */}
                    <Button
                        danger
                        icon={<DeleteOutlined />}
                        size="small"
                        onClick={() => {
                            Modal.confirm({
                                title: '¿Eliminar esta habitación?',
                                content: 'Esta acción no se puede deshacer',
                                okText: 'Sí',
                                okType: 'danger',
                                cancelText: 'No',
                                onOk: () => eliminarHabitacion(record),
                            });
                        }}/>                    
                </Tooltip> 
            )}
          </Space>
        );
      },
    });
  // }
  
  return baseColumns;
};

  // Header sticky
  const renderHeaderSticky = () => (
    <Affix offsetTop={0}>
      <div style={{
        backgroundColor: '#fff',
        padding: '16px 0',
        marginBottom: '16px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
        borderBottom: '1px solid #f0f0f0'
      }}>
        <div style={{ 
          maxWidth: '1200px', 
          margin: '0 auto',
          padding: '0 24px' 
        }}>
         

          <>
            {/* Primera fila - Tags */}
            <Row style={{ marginBottom: 16 }}>
              <Col>
                <Space>
                  {reserva && (
                    <Space>
                      {/* {reserva.Anulada ? (
                        <Tag color="red">ANULADA</Tag>
                      ) : reserva.Facturado ? (
                        <Tag color="orange">FACTURADA</Tag>
                      ) : (
                        <Tag color="green">ACTIVA</Tag>
                      )} */}
                      {reserva.AgenciaXML ? <Tag color="blue" onClick={()=> handleMarcarIndividual(reserva)}> Reserva Integrada. Imp.Integración : {reserva.ImporteIntegracion}</Tag>:``}
                      <Tag color="green">Importe reserva: {reserva.ImporteReserva.toFixed(2)}</Tag>
                      <Tag color="green">Entrada: {dayjs(reserva.Entrada).format('DD/MM/YY')} Salida: {dayjs(reserva.Salida).format('DD/MM/YY')}</Tag>
                      <Tag color="orange">Regimen: {reserva.Regimen} Ser. Entrada: {reserva.SerEntrada} Ser. Salida: {reserva.SerSalida}</Tag>
                    </Space>
                  )}
                </Space>
              </Col>
            </Row>

            {/* Segunda fila - Botones */}
            <Row justify="end">
              <Col>
                <Space>
                  {editMode ? (
                    <>
                      <Button
                        icon={<SaveOutlined />}
                        type="primary"
                        onClick={handleGuardarReserva}
                        loading={loading}
                        size="middle"
                      >
                        Guardar
                      </Button>
                      <Button
                        icon={<CloseOutlined />}
                        onClick={handleCancelarEdicion}
                        size="middle"
                      >
                        Cancelar
                      </Button>
                    </>
                  ) : (
                    <>
                      {reserva && !reserva.Facturado && (
                        <Button
                          icon={<EditOutlined />}
                          type="primary"
                          onClick={() => setEditMode(true)}
                          size="middle"
                        >
                          Editar
                        </Button>
                      )}
                      <Button
                        icon={<EyeOutlined />}
                        onClick={() => window.history.back()}
                        size="middle"
                      >
                        Volver a Lista
                      </Button>
                      
                      {reserva && (
                        <>
                          <Button onClick={() => abrirDistribucion('12345')}>
                              Abrir Distribución
                          </Button>                      
                          <Button 
                            type="link"
                            icon={<CreditCardOutlined />}
                            onClick={() => setDepositosModalVisible(true)}
                            size="middle"
                          >
                            Depósitos
                          </Button>
                          
                          <Button
                            type="link"
                            icon={<DollarOutlined />}
                            onClick={() => setCargosModalVisible(true)}
                            size="middle"
                          >
                            Cargos
                          </Button>

                          <Button 
                              icon={<ReloadOutlined />} 
                              onClick={() => {   
                                          setReservaSeleccionada(reserva);
                                          setFacturacionModalVisible(true);
                                      }
                                    }
                          >
                              Facturar
                          </Button>                                  
                        </>
                      )}
                    </>
                  )}
                </Space>
              </Col>
            </Row>
          </>          
        </div>
      </div>
    </Affix>
  );

  // Renderizar el formulario
  const renderFormulario = () => (
<Form
              form={form}
              layout="vertical"
              disabled={!editMode}
            >
              <Row gutter={16}>
                <Col span={24}>
                  <Title level={4} style={{ marginBottom: 24 }}>
                    <CalendarOutlined /> Información de la Reserva
                  </Title>
                </Col>
              </Row>
              
              <Row gutter={16}>
<Col span={8}>
    <Form.Item
      name="Fechareserva"
      label="Fecha Reserva"
    >
      <DatePicker 
        style={{ width: '100%' }} 
        format="DD/MM/YYYY"
        disabled
      />
    </Form.Item>
  </Col>


  
  <Col span={8}>


    <Form.Item
      name="FechaBooking"
      label="Fecha Booking"
    >
      <DatePicker 
        style={{ width: '100%' }} 
       format="DD/MM/YYYY"
       
      />
    </Form.Item>


  </Col>    
  </Row>            
  <Row gutter={16}>
                <Col span={8}>
<Form.Item
  name="Agencia"
  label="Agencia"
  rules={[{ required: true, message: 'La agencia es obligatoria' }]}
>
  <Input
    placeholder="Código agencia"
    onBlur={(e) => buscarAgenciaPorCodigo(e.target.value)}
    suffix={
      <Button
        type="link"
        size="small"
        onClick={() => abrirModalBusqueda('agencia')}
        icon={<SearchOutlined />}
      />
    }
  />
</Form.Item>

                    {agenciaNombre && (
                    <Typography.Text
                        type="secondary"
                        style={{
                        marginTop: -16,
                        marginBottom: 12,
                        display: 'block',
                        fontSize: 12
                        }}
                    >
                        {agenciaNombre}
                    </Typography.Text>
                    )}                              

  </Col>
                <Col span={6}>
<Form.Item
  name="SubAgen"
  label="Subagencia"
>
  <Input
    placeholder="Código subagencia"
    onBlur={(e) => buscarSubagenciaPorCodigo(e.target.value)}
    suffix={
      <Button
        type="link"
        size="small"
        onClick={() => abrirModalBusqueda('subagencia')}
        icon={<SearchOutlined />}
      />
    }
  />
</Form.Item>

{subagenciaNombre && (
  <Typography.Text
    type="secondary"
    style={{
      marginTop: -16,
      marginBottom: 12,
      display: 'block',
      fontSize: 12
    }}
  >
    {subagenciaNombre}
  </Typography.Text>
)}
                </Col>
                <Col span={6}>
                  <Form.Item
                    name="SNumero"
                    label="Localizador"
                    rules={[{ required: true, message: 'El localizador es obligatorio.' }]}
                    extra={
                      <Button 
                        type="link" 
                        size="small" 
                        onClick={() => obtenerUltimoLocalizador(form.getFieldValue('Agencia'))}
                      >
                        Generar automático
                      </Button>
                    }
                  >
                    <Input placeholder="10 dígitos" maxLength={10} />
                  </Form.Item>
                </Col>
              </Row>
              
              <Row gutter={16}>
                <Col span={8}>
                  <Form.Item
                    name="Nombre"
                    label="Nombre Cliente"
                    rules={[{ required: true, message: 'El nombre es obligatorio' }]}
                  >
                    <Input 
                      placeholder="Nombre del cliente" 
                      prefix={<UserOutlined />}
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    name="Telefono"
                    label="Teléfono"
                  >
                    <Input 
                      placeholder="Teléfono" 
                      prefix={<PhoneOutlined />}
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    name="CorreoElectronico"
                    label="Email"
                  >
                    <Input 
                      placeholder="Email" 
                      prefix={<MailOutlined />}
                    />
                  </Form.Item>
                </Col>
              </Row>
              
              <Row gutter={16}>
                <Col span={8}>
<Form.Item
                    name="CodParti"
                    label="Particular"
                    
                    shouldUpdate={false}
                >
                    <Input
                        readOnly
                        placeholder="Seleccione un particular"
                        //onClick={() => abrirModalBusqueda('agencia')}
                        suffix={
                                <Button 
                                type="link" 
                                size="small"
                                onClick={() => {
                                    abrirModalBusqueda('particular')
                                }}
                                icon={<SearchOutlined />}
                                >
                                
                                </Button>
                            }                        
                    />
                </Form.Item> 
                </Col>
                <Col span={8}>
                  <Form.Item
                    name="Nacion"
                    label="País"
                  >
                    <Select
                      showSearch
                      placeholder="Seleccione país"
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.children.toLowerCase().includes(input.toLowerCase())
                      }
                      allowClear
                    >
                      {paises.map(pais => (
                        <Option key={pais.Codigo} value={pais.Nombre}>
                          {pais.Nombre}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    name="Provincia"
                    label="Provincia"
                    dependencies={['Nacion']}
                  >
                    {({ getFieldValue }) => {
                      const pais = getFieldValue('Nacion');
                      const esEspana = pais === 'ESPAÑA';
                      
                      return (
                        <Select
                          placeholder="Seleccione provincia"
                          disabled={!esEspana}
                          allowClear
                        >
                          {esEspana && provincias.map(provincia => (
                            <Option key={provincia.Codigo} value={provincia.Nombre}>
                              {provincia.Nombre}
                            </Option>
                          ))}
                        </Select>
                      );
                    }}
                  </Form.Item>
                </Col>
              </Row>
              
              <Row gutter={16}>
                <Col span={6}>
                  <Form.Item
                    name="Entrada"
                    label="Fecha Entrada"
                    rules={[{ required: true, message: 'La fecha de entrada es obligatoria' }]}
                  >
                    <DatePicker 
                      style={{ width: '100%' }} 
                      format="DD/MM/YYYY"
                    />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    name="Salida"
                    label="Fecha Salida"
                    rules={[{ required: true, message: 'La fecha de salida es obligatoria' }]}
                  >
                    <DatePicker 
                      style={{ width: '100%' }} 
                      format="DD/MM/YYYY"
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    name="HabitacionEspecial"
                    label="Habitación Venta"
                  >
                    <Select
                      showSearch
                      placeholder="Seleccione habitación venta"
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.children.toLowerCase().includes(input.toLowerCase())
                      }
                      allowClear
                    >
                      {habitacionesVenta.map(hab => (
                        <Option key={hab.Codigo} value={hab.Codigo}>
                          {hab.Codigo} - {hab.Descripcion}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
              
              <Row gutter={16}>
  <Col span={24}>
    <Title level={5} style={{ marginBottom: 16 }}>
      <TeamOutlined /> Habitaciones
    </Title>
  </Col>
  <Col span={3}>
    <Form.Item
      name="I_"
      label="Individuales (IN)"
    >
      <InputNumber 
        min={0}
        max={99}
        style={{ width: '100%' }}
        size="small"
        controls={true}
        parser={(value) => Math.max(0, parseInt(value) || 0)}
        formatter={(value) => Math.max(0, parseInt(value) || 0)}
      />
    </Form.Item>
  </Col>
  <Col span={3}>
    <Form.Item
      name="DO"
      label="Dobles (DO)"
    >
      <InputNumber 
        min={0}
        max={99}
        style={{ width: '100%' }}
        size="small"
        controls={true}
        parser={(value) => Math.max(0, parseInt(value) || 0)}
        formatter={(value) => Math.max(0, parseInt(value) || 0)}
      />
    </Form.Item>
  </Col>
  <Col span={3}>
    <Form.Item
      name="TR"
      label="Triples (TR)"
    >
      <InputNumber 
        min={0}
        max={99}
        style={{ width: '100%' }}
        size="small"
        controls={true}
        parser={(value) => Math.max(0, parseInt(value) || 0)}
        formatter={(value) => Math.max(0, parseInt(value) || 0)}
      />
    </Form.Item>
  </Col>
  <Col span={3}>
    <Form.Item
      name="CU"
      label="Cuádruples (CU)"
    >
      <InputNumber 
        min={0}
        max={99}
        style={{ width: '100%' }}
        size="small"
        controls={true}
        parser={(value) => Math.max(0, parseInt(value) || 0)}
        formatter={(value) => Math.max(0, parseInt(value) || 0)}
      />
    </Form.Item>
  </Col>
  <Col span={3}>
    <Form.Item
      name="QU"
      label="Quintuples (QU)"
    >
      <InputNumber 
        min={0}
        max={99}
        style={{ width: '100%' }}
        size="small"
        controls={true}
        parser={(value) => Math.max(0, parseInt(value) || 0)}
        formatter={(value) => Math.max(0, parseInt(value) || 0)}
      />
    </Form.Item>
  </Col>

  <Col span={4}>
    <Form.Item
      name="Habitaciones"
      label="Total Hab."
    >
      <InputNumber 
        min={0}
        style={{ width: '100%' }}
        size="small"
        disabled={true}
        readOnly
      />
    </Form.Item>
  </Col>
</Row>
              <Row gutter={16}>
                <Col span={4}>
                  <Form.Item
                    name="dto"
                    label="Descuento %"
                  >
                    <InputNumber 
                      min={0} 
                      max={100} 
                      style={{ width: '100%' }}
                      formatter={value => `${value}%`}
                      parser={value => value.replace('%', '')}
                    />
                  </Form.Item>
                </Col>
              </Row>
              
              <Row gutter={16}>
                <Col span={24}>
                  <Title level={5} style={{ marginBottom: 16 }}>
                    <FileTextOutlined /> Observaciones
                  </Title>
                </Col>
                <Col span={8}>
                  <Form.Item
                    name="Observa"
                    label="Observaciones"
                  >
                    <Input.TextArea rows={3} />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    name="observacionesf"
                    label="Observaciones F"
                  >
                    <Input.TextArea rows={3} />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    name="observacionesf"
                    label="Observaciones I"
                  >
                    <Input.TextArea rows={3} />
                  </Form.Item>
                </Col>
              </Row>
              
              <Row gutter={16}>
                <Col span={24}>
                  <Title level={5} style={{ marginBottom: 16 }}>
                    <SettingOutlined /> Configuración
                  </Title>
                </Col>
                <Col span={6}>
                  <Form.Item
                    name="FPago"
                    label="Forma de Pago"
                  >
                    <Select>
                      <Option value={0}>Crédito</Option>
                      <Option value={1}>Pago Directo</Option>
                      <Option value={2}>Prepago</Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    name="FacturarTasa"
                    label="Facturar tasa"
                  >
                    <Select>
                      <Option value={0}>Facturar en habitación</Option>
                      <Option value={1}>Facturar en extra</Option>
                    </Select>
                  </Form.Item>
                </Col>
            </Row>
            <Row gutter={16}>  
                <Col span={6}>
                  <Form.Item
                    name="Regimen"
                    label="Régimen"
                  >
                    <Select
                      showSearch
                      placeholder="Seleccione régimen"
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.children.toLowerCase().includes(input.toLowerCase())
                      }
                        onChange={(value) => {
                            actualizarServiciosPorRegimen(value);
                        }}
                    >
                      {regimenes.map(regimen => (
                        <Option key={regimen.Codigo} value={regimen.Codigo}>
                          {regimen.Codigo} - {regimen.Descripcion}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    name="SerEntrada"
                    label="Servicio Entrada"
                  >
                    <Select placeholder="Seleccione servicio entrada">
                      <Option value="HA">Habitación</Option>
                      <Option value="DE">Desayuno</Option>
                      <Option value="AL">Almuerzo</Option>
                      <Option value="CE">Cena</Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    name="SerSalida"
                    label="Servicio Salida"
                  >
                    <Select placeholder="Seleccione servicio salida">
                      <Option value="HA">Habitación</Option>
                      <Option value="DE">Desayuno</Option>
                      <Option value="AL">Almuerzo</Option>
                      <Option value="CE">Cena</Option>
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
              
              <Row gutter={16}>
                <Col span={6}>
                  <Form.Item
                    name="RegMp"
                    label="Reg. MP"
                    dependencies={['Regimen']}
                  >
                    {({ getFieldValue }) => {
                      const regimen = getFieldValue('Regimen');
                      const esMP = regimen === 'MP';
                      
                      return (
                        <Select placeholder="Seleccione" disabled={!esMP}>
                          <Option value="0">Cena</Option>
                          <Option value="2">Almuerzo</Option>
                        </Select>
                      );
                    }}
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    name="TipoCliente"
                    label="Tipo Cliente"
                  >
                    <Select
                      showSearch
                      placeholder="Seleccione tipo cliente"
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.children.toLowerCase().includes(input.toLowerCase())
                      }
                    >
                      {tiposCliente.map(tipo => (
                        <Option key={tipo.Codigo} value={tipo.Codigo}>
                          {tipo.Descripcion}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    name="PoliticaCancelacion"
                    label="Política Cancelación"
                  >
                    <Select
                      showSearch
                      placeholder="Seleccione política"
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.children.toLowerCase().includes(input.toLowerCase())
                      }
                    >
                      {politicasCancelacion.map(politica => (
                        <Option key={politica.Codigo} value={politica.Codigo}>
                          {politica.Descripcion}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    name="Idioma"
                    label="Idioma"
                  >
                    <Select
                      showSearch
                      placeholder="Seleccione idioma"
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.children.toLowerCase().includes(input.toLowerCase())
                      }
                    >
                      {idiomas.map(idioma => (
                        <Option key={idioma.Codigo} value={idioma.Codigo}>
                          {idioma.Descripcion}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
              
              <Row gutter={16}>
                <Col span={6}>
                  <Form.Item
                    name="TipoComunicacion"
                    label="Tipo Comunicación"
                  >
                    <Select
                      showSearch
                      placeholder="Seleccione tipo"
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.children.toLowerCase().includes(input.toLowerCase())
                      }
                    >
                      {tiposComunicacion.map(tipo => (
                        <Option key={tipo.Codigo} value={tipo.Codigo}>
                          {tipo.Descripcion}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    name="estado"
                    label="Estado Reserva"
                  >
                    <Select
                      showSearch
                      placeholder="Seleccione estado"
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.children.toLowerCase().includes(input.toLowerCase())
                      }
                    >
                      {estadosReserva.map(estado => (
                        <Option key={estado.Codigo} value={estado.Codigo}>
                          {estado.Descripcion}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    name="Serie"
                    label="Serie Facturación"
                  >
                    <Select
                      showSearch
                      placeholder="Seleccione serie"
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.children.toLowerCase().includes(input.toLowerCase())
                      }
                    >
                      {series.map(serie => (
                        <Option key={serie.Codigo} value={serie.Codigo}>
                          {serie.Descripcion}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <div style={{ paddingTop: 30 }}>
                    <Form.Item
                      name="esGrupoHabitaciones"
                      valuePropName="checked"
                    >
                      <Checkbox>Es Grupo Habitaciones</Checkbox>
                    </Form.Item>
                    <Form.Item
                      name="ReservadeBloqueo"
                      valuePropName="checked"
                    >
                      <Checkbox>Reserva de Bloqueo</Checkbox>
                    </Form.Item>
                    <Form.Item
                      name="NoReembolsable"
                      valuePropName="checked"
                    >
                      <Checkbox>No Reembolsable</Checkbox>
                    </Form.Item>
                  </div>
                </Col>
              </Row>
            </Form>
  );

  return (
    <PageContainer
      title={reserva ? `Reserva #${reserva.NumReserva}` : 'Nueva Reserva'}
      subtitle={reserva ? reserva.Nombre : 'Crear nueva reserva'}
      icon={<CalendarOutlined />}
      loading={loading}
      onRefresh={() => reserva && fetchReserva(reserva.NumReserva)}
      extra={
        reserva && (
          <Space>
            <Badge 
              status={reserva.Anulada ? 'error' : reserva.Facturado ? 'success' : 'processing'} 
              text={reserva.Anulada ? 'Anulada' : reserva.Facturado ? 'Facturada' : 'Activa'}
            />
          </Space>
        )
      }
    >
      {renderHeaderSticky()}
      
      <Tabs defaultActiveKey="1">
        <TabPane tab="Datos Generales" key="1">
          {renderFormulario()}
        </TabPane>
        
        <TabPane tab="Líneas de Reserva" key="2" disabled={editMode}>
          {/* Contenido de líneas de reserva similar al original */}
          <div style={{ marginBottom: 16 }}>
            <Space>
              { !reserva?.Facturado && (
                <Dropdown
                  menu={{
                    items: [
                      { key: 'IN', label: 'Individual (1 persona)', icon: <UserOutlined /> },
                      { key: 'DO', label: 'Doble (2 personas)', icon: <TeamOutlined /> },
                      { key: 'TR', label: 'Triple (3 personas)', icon: <TeamOutlined /> },
                      { key: 'CU', label: 'Cuádruple (4 personas)', icon: <TeamOutlined /> },
                      { key: 'QU', label: 'Quintuple (5 personas)', icon: <TeamOutlined /> },
                    ],
                    onClick: ({ key }) => añadirHabitacionAutomatica(key),
                  }}
                  placement="bottomLeft"
                >
                  <Button type="primary" icon={<PlusOutlined />}>
                    Añadir Habitación
                  </Button>
                </Dropdown>
              )}



              <Button 
                icon={<ReloadOutlined />} 
                onClick={() => reserva && fetchLineasReserva(reserva.NumReserva)}
              >
                Actualizar
              </Button>

                <Button 
                    icon={<HomeOutlined />}
                    onClick={() => abrirDrawerAsignacion()}
                    disabled={!lineaSeleccionadaAsignacion}
                >
                    Asignar Habitación 
                </Button>               
            </Space>
          </div>
          
          {/* Tabla de líneas */}
            <Table
              columns={getColumnasLineasConAcciones()}
              // dataSource={lineasReserva}
              dataSource={agruparLineasPorHabitacion()}
              rowKey={record => `${record.Linea}-${record.Numocupante}`}
              size="small"
              pagination={false}
              loading={loadingLineas}
              rowSelection={{
                type: 'radio',
                selectedRowKeys: lineaSeleccionadaAsignacion ? [`${lineaSeleccionadaAsignacion.Linea}-${lineaSeleccionadaAsignacion.Numocupante}`] : [],
                onSelect: (record) => {
                  setLineaSeleccionadaAsignacion(record);
                  if (drawerAsignacionVisible) {
                    // Si el drawer está abierto, actualizar las habitaciones disponibles
                    cargarHabitacionesDisponibles(record);
                  }
                },
                columnWidth: 50,
              }}              
              components={{
                    body: {
                      row: ({ className, style, ...restProps }) => {
                        // Determinar el color de fondo según el número de línea
                        const record = restProps['data-row-key'] 
                          ? lineasReserva.find(l => `${l.Linea}-${l.Numocupante}` === restProps['data-row-key'])
                          : null;
                        
                        let bgColor = '#ffffff'; // Blanco por defecto
                        
                        if (record) {
                          // Alternar colores basado en el número de línea
                          const esLineaPar = record.Linea % 2 === 0;
                          bgColor = esLineaPar ? '#9a9ea1b7' : '#ffffff';
                          
                          // Si está anulada, usar un color diferente
                          if (record.Anulada === 1) {
                            bgColor = '#fff2f0';
                          } else if (record.NFactura > 0) {
                            bgColor = '#fff7e6'; // Color para facturadas
                          }

                          if (lineaSeleccionadaAsignacion && 
                              lineaSeleccionadaAsignacion.Linea === record.Linea && 
                              lineaSeleccionadaAsignacion.Numocupante === record.Numocupante) {
                            bgColor = '#f6ffed';
                          }                          
                        }
                        
                        return (
                          <tr
                            {...restProps}
                            className={className}
                            style={{
                              ...style,
                              backgroundColor: bgColor,
                              transition: 'background-color 0.3s ease',
                              cursor: 'pointer'
                            }}
                          />
                        );
                      },
                    },
                  }}                  
                  rowClassName={(record) => {
                    // Clases adicionales para el hover
                    return 'linea-habitacion';
                  }}
                  onRow={(record) => ({
                    onClick: () => {
                      setLineaSeleccionadaAsignacion(record);
                      if (drawerAsignacionVisible) {
                        cargarHabitacionesDisponibles(record);
                      }
                    },
                  })}              
                  summary={() => (
                        <Table.Summary fixed>
                          <Table.Summary.Row style={{ backgroundColor: '#fafafa' }}>
                            <Table.Summary.Cell index={0} colSpan={3}>
                              <Text strong>Total Habitaciones:</Text>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell index={1}>
                              <Badge 
                                count={calcularTotalHabitaciones()} 
                                style={{ backgroundColor: '#1890ff' }}
                              />
                            </Table.Summary.Cell>
                            <Table.Summary.Cell index={2} colSpan={2}>
                              <Text strong>Total Personas:</Text>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell index={3}>
                              <Badge 
                                count={calcularTotalPersonas()} 
                                style={{ backgroundColor: '#52c41a' }}
                              />
                            </Table.Summary.Cell>
                          </Table.Summary.Row>
                        </Table.Summary>
                      )}
            />
<AsignacionHabitacionesDrawer
            drawerAsignacionVisible={drawerAsignacionVisible}
            onClose={() => setDrawerAsignacionVisible(false)}
            lineaSeleccionadaAsignacion={lineaSeleccionadaAsignacion}
            habitacionesDisponibles={habitacionesDisponibles}
            // habitacionAsignada={habitacionAsignada}
            cargandoAsignacion={cargandoAsignacion}
            asignarHabitacion={asignarHabitacion}            
            plantasDisponibles={plantasDisponibles}
            tiposHabitacionDisponibles={tiposHabitacionDisponibles}
            cargandoHabitacionesDisponibles={cargandoHabitacionesDisponibles}
            desasignarHabitacion={desasignarHabitacion}
            cerrarDrawerAsignacion={cerrarDrawerAsignacion}
          />

            
            
            {/* Modal para editar línea/persona */}
            <Modal
              title={modoEdicionLinea === 'persona' ? `Editar Persona - Habitación ${lineaEditando?.Linea || ''}` : `Editar Habitación ${lineaEditando?.Linea || ''}`}
              open={modalLineaVisible}
              onCancel={() => cerrarModalLinea()}
              width={800}
              footer={[
                <Button key="cancel" onClick={() => cerrarModalLinea()}>
                  Cancelar
                </Button>,
                <Button 
                  key="submit" 
                  type="primary" 
                  loading={guardandoLinea}
                  onClick={() => guardarCambiosLinea()}
                >
                  Guardar Cambios
                </Button>
              ]}
              destroyOnClose
            >
              {modalLineaVisible && lineaEditando && (
                <Form
                  form={formLinea}
                  layout="vertical"
                  disabled={lineaEditando?.NFactura > 0}
                >
        
                  {modoEdicionLinea === 'persona' ? (
                    // Formulario para editar solo persona
                    <>
                      <Row gutter={16}>
                        <Col span={12}>
                          <Form.Item
                            name="Nombre"
                            label="Nombre"
                            rules={[{ required: true, message: 'El nombre es obligatorio' }]}
                          >
                            <Input placeholder="Nombre del cliente" />
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item
                            name="CodParti"
                            label="Particular"
                          >
                            <Input
                              placeholder="Código particular"
                              suffix={
                                <Button
                                  type="link"
                                  size="small"
                                  onClick={() => abrirModalBusquedaParticular()}
                                  icon={<SearchOutlined />}
                                />
                              }
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      
                      <Row gutter={16}>
                        <Col span={8}>
                          <Form.Item
                            name="Nacion"
                            label="Nacionalidad"
                          >
                            <Select
                              showSearch
                              placeholder="Seleccione nacionalidad"
                              optionFilterProp="children"
                              filterOption={(input, option) =>
                                option.children.toLowerCase().includes(input.toLowerCase())
                              }
                            >
                              {paises.map(pais => (
                                <Option key={pais.Codigo} value={pais.Nombre}>
                                  {pais.Nombre}
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Col>
                        
                        <Col span={8}>
                          <Form.Item
                            name="TipoFac"
                            label="Tipo Facturación"
                          >
                            <Select
                              placeholder="Seleccione tipo"
                              onChange={(value) => handleCambioTipoFacturacion(value)}
                            >
                              {tiposFacturacion.map(tipo => (
                                <Option key={tipo.Codigo} value={tipo.Codigo}>
                                  {tipo.Codigo} - {tipo.Descripcion}
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Col>
                        
                        {mostrarCampoEdad && (
                          <Col span={8}>
                            <Form.Item
                              name="EdadNino"
                              label="Edad Niño"
                            >
                              <InputNumber 
                                min={0} 
                                max={18}
                                style={{ width: '100%' }}
                              />
                            </Form.Item>
                          </Col>
                        )}
                      </Row>
                      
                      <Row gutter={16}>
                        <Col span={8}>
                          <Form.Item
                            name="Entrada"
                            label="Fecha Entrada"
                            rules={[{ required: true, message: 'La fecha de entrada es obligatoria' }]}
                          >
                            <DatePicker 
                              style={{ width: '100%' }} 
                              format="DD/MM/YYYY"
                            />
                          </Form.Item>
                        </Col>
                        
                        <Col span={8}>
                          <Form.Item
                            name="Salida"
                            label="Fecha Salida"
                            rules={[{ required: true, message: 'La fecha de salida es obligatoria' }]}
                          >
                            <DatePicker 
                              style={{ width: '100%' }} 
                              format="DD/MM/YYYY"
                            />
                          </Form.Item>
                        </Col>                        
                      </Row>

                      
                      <Row gutter={16}>
                        <Col span={6}>
                          <Form.Item
                            name="Regimen"
                            label="Régimen"
                          >
                            <Select
                              showSearch
                              placeholder="Seleccione régimen"
                              optionFilterProp="children"
                              filterOption={(input, option) =>
                                option.children.toLowerCase().includes(input.toLowerCase())
                              }
                              onChange={(value) => handleCambioRegimenLinea(value)}
                            >
                              {regimenes.map(regimen => (
                                <Option key={regimen.Codigo} value={regimen.Codigo}>
                                  {regimen.Codigo} - {regimen.Descripcion}
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col span={6}>
                          <Form.Item
                            name="SerEntrada"
                            label="Servicio Entrada"
                          >
                            <Select placeholder="Seleccione servicio entrada">
                              <Option value="HA">Habitación</Option>
                              <Option value="DE">Desayuno</Option>
                              <Option value="AL">Almuerzo</Option>
                              <Option value="CE">Cena</Option>
                            </Select>
                          </Form.Item>
                        </Col>
                        
                        <Col span={6}>
                          <Form.Item
                            name="SerSalida"
                            label="Servicio Salida"
                          >
                            <Select placeholder="Seleccione servicio salida">
                              <Option value="HA">Habitación</Option>
                              <Option value="DE">Desayuno</Option>
                              <Option value="AL">Almuerzo</Option>
                              <Option value="CE">Cena</Option>
                            </Select>
                          </Form.Item>
                        </Col>
                        
                        {mostrarServicioCocina && (
                          <Col span={8}>
                            <Form.Item
                              name="ServicioCocinaMP"
                              label="Servicio Cocina MP"
                            >
                              <Select placeholder="Seleccione servicio">
                                <Option value="0">Cena</Option>
                                <Option value="2">Almuerzo</Option>
                              </Select>
                            </Form.Item>
                          </Col>
                        )}
                      </Row>
                    </>
                  ) : (
                    // Formulario para editar habitación completa
                    <>
                      <Row gutter={16}>
                        <Col span={8}>
                          <Form.Item
                            name="Entrada"
                            label="Fecha Entrada"
                            rules={[{ required: true, message: 'La fecha de entrada es obligatoria' }]}
                          >
                            <DatePicker 
                              style={{ width: '100%' }} 
                              format="DD/MM/YYYY"
                            />
                          </Form.Item>
                        </Col>
                        
                        <Col span={8}>
                          <Form.Item
                            name="Salida"
                            label="Fecha Salida"
                            rules={[{ required: true, message: 'La fecha de salida es obligatoria' }]}
                          >
                            <DatePicker 
                              style={{ width: '100%' }} 
                              format="DD/MM/YYYY"
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row gutter={16}>
                        <Col span={8}>
                          <Form.Item
                            name="NumHab"
                            label="Número Habitación"
                            help={mensajeDisponibilidad}
                          >
                            <InputNumber 
                              min={0}
                              disabled
                              style={{ width: '100%' }}
                              onChange={(value) => validarDisponibilidadHabitacion(value)}
                            />
                          </Form.Item>
                        </Col>
                      
                        <Col span={12}>
                          <Form.Item
                            name="HabitacionVenta"
                            label="Habitación Venta"
                          >
                            <Select
                              showSearch
                              placeholder="Seleccione habitación venta"
                              optionFilterProp="children"
                              filterOption={(input, option) =>
                                option.children.toLowerCase().includes(input.toLowerCase())
                              }
                            >
                              {habitacionesVenta.map(hab => (
                                <Option key={hab.Codigo} value={hab.Codigo}>
                                  {hab.Codigo} - {hab.Descripcion}
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Col>
                      </Row>                      
                      <Row gutter={16}>
                        <Col span={8}>
                          <Form.Item
                            name="Regimen"
                            label="Régimen"
                          >
                            <Select
                              showSearch
                              placeholder="Seleccione régimen"
                              optionFilterProp="children"
                              filterOption={(input, option) =>
                                option.children.toLowerCase().includes(input.toLowerCase())
                              }
                              onChange={(value) => handleCambioRegimenLinea(value)}
                            >
                              {regimenes.map(regimen => (
                                <Option key={regimen.Codigo} value={regimen.Codigo}>
                                  {regimen.Codigo} - {regimen.Descripcion}
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Col>
                        
                        <Col span={8}>
                          <Form.Item
                            name="SerEntrada"
                            label="Servicio Entrada"
                          >
                            <Select placeholder="Seleccione servicio entrada">
                              <Option value="HA">Habitación</Option>
                              <Option value="DE">Desayuno</Option>
                              <Option value="AL">Almuerzo</Option>
                              <Option value="CE">Cena</Option>
                            </Select>
                          </Form.Item>
                        </Col>
                        
                        <Col span={8}>
                          <Form.Item
                            name="SerSalida"
                            label="Servicio Salida"
                          >
                            <Select placeholder="Seleccione servicio salida">
                              <Option value="HA">Habitación</Option>
                              <Option value="DE">Desayuno</Option>
                              <Option value="AL">Almuerzo</Option>
                              <Option value="CE">Cena</Option>
                            </Select>
                          </Form.Item>
                        </Col>
                      </Row>
                      
                      {mostrarServicioCocina && (
                        <Row gutter={16}>
                          <Col span={8}>
                            <Form.Item
                              name="ServicioCocinaMP"
                              label="Servicio Cocina MP"
                            >
                              <Select placeholder="Seleccione servicio">
                                <Option value="0">Cena</Option>
                                <Option value="2">Almuerzo</Option>
                              </Select>
                            </Form.Item>
                          </Col>
                        </Row>
                      )}
                    </>
                  )}
                  
                  {/* Observación separada */}
                  <Divider>Observación</Divider>
                  <Form.Item
                    name="Observacion"
                    label="Observación para esta línea"
                  >
                    <Input.TextArea 
                      rows={3} 
                      placeholder="Observaciones específicas para esta persona/habitación"
                    />
                  </Form.Item>
                  
                  {/* Información de estado */}
                  {lineaEditando?.NFactura > 0 && (
                    <Alert
                      message="Esta línea está facturada"
                      description="No se pueden realizar modificaciones porque la línea ya ha sido facturada."
                      type="warning"
                      showIcon
                    />
                  )}
                </Form>
              )}
            </Modal>
            
            {/* Modal para buscar particular */}
            <Modal
              title="Buscar Particular"
              open={modalBuscarParticularVisible}
              onCancel={() => setModalBuscarParticularVisible(false)}
              width={800}
              footer={null}
            >
              <Space direction="vertical" style={{ width: '100%' }}>
                <Input.Search
                  placeholder="Buscar por código o nombre..."
                  value={filtroParticular}
                  onChange={(e) => setFiltroParticular(e.target.value)}
                  onSearch={(value) => buscarParticulares(value)}
                  style={{ marginBottom: 16 }}
                />
                
                <Table
                  columns={[
                    {
                      title: 'Código',
                      dataIndex: 'Codigo',
                      key: 'Codigo',
                      width: 100,
                    },
                    {
                      title: 'Nombre',
                      dataIndex: 'Nombre',
                      key: 'Nombre',
                      ellipsis: true,
                    },
                    {
                      title: 'Email',
                      dataIndex: 'Email',
                      key: 'Email',
                      width: 150,
                    },
                    {
                      title: 'Teléfono',
                      dataIndex: 'Telefono1',
                      key: 'Telefono1',
                      width: 120,
                    },
                    {
                      title: 'Acción',
                      key: 'accion',
                      width: 80,
                      render: (_, record) => (
                        <Button
                          type="primary"
                          size="small"
                          onClick={() => seleccionarParticularLinea(record)}
                        >
                          Seleccionar
                        </Button>
                      ),
                    },
                  ]}
                  dataSource={particularesBusqueda}
                  rowKey="Codigo"
                  loading={cargandoParticulares}
                  pagination={paginacionParticular}
                  onChange={(pagination) => {
                    buscarParticulares(filtroParticular, pagination.current);
                  }}
                  size="small"
                />
              </Space>
            </Modal>            
        </TabPane>
        

        <TabPane tab="Precios" key="3" disabled={editMode}>
        <div style={{ padding: 16 }}>
            <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
            <Col span={24}>
                <Card title="Tipo de Precio" size="small">
                <Radio.Group 
                    value={tipoPrecio} 
                    onChange={(e) => setTipoPrecio(e.target.value)}
                    style={{ width: '100%' }}
                >
                    <Radio.Button value="manual" style={{ width: '50%', textAlign: 'center' }}>
                    Precio Manual
                    </Radio.Button>
                    <Radio.Button value="contrato" style={{ width: '50%', textAlign: 'center' }}>
                    Precio por Contrato
                    </Radio.Button>
                </Radio.Group>
                </Card>
            </Col>
            </Row>

            {tipoPrecio === 'contrato' ? (
            <Card 
                title="Seleccionar Contrato" 
                size="small"
                style={{ marginBottom: 24 }}
            >
                <Row gutter={[16, 16]}>
                <Col span={24}>
                    <Select
                        style={{ width: '100%' }}
                        placeholder="Seleccione un contrato"
                        value={contratoSeleccionado}
                        onChange={handleCambioContrato}                        
                        loading={cargandoContratos}
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                            option.children.toLowerCase().includes(input.toLowerCase())
                        }
                    >
                    {contratos
                        .filter(contrato => !contrato.Bloqueado)
                        .map(contrato => (
                        <Option key={contrato.Codigo} value={contrato.Codigo}>
                            {contrato.Codigo} - {contrato.Descripcion} 
                            {contrato.agencia && ` (Agencia: ${contrato.agencia})`}
                        </Option>
                        ))
                    }
                    </Select>
                </Col>
                {contratoSeleccionado && (
                    <Col span={24}>
                        <Alert
                            message="Contrato Seleccionado"
                            description={
                            contratos.find(c => c.Codigo === contratoSeleccionado)?.Descripcion || ''
                            }
                            type="info"
                            showIcon
                            style={{ marginBottom: 16 }}
                        />
                        {/* Tabla de líneas del contrato */}
                        {cargandoContratos ? (
                            <div style={{ textAlign: 'center', padding: '20px' }}>
                                <LoadingOutlined style={{ fontSize: 24 }} spin />
                                <div style={{ marginTop: 8 }}>Cargando líneas del contrato...</div>
                            </div>
                        ) : lineasContratoCargadas.length > 0 ? (
                            <Card 
                                size="small" 
                                title={`Líneas del Contrato (${lineasContratoCargadas.length})`}
                                style={{ marginTop: 8 }}
                            >
                                <Table
                                    size="small"
                                    dataSource={lineasContratoCargadas}
                                    rowKey="codigo"
                                    pagination={{ pageSize: 5 }}
                                    expandable={{
                                        expandedRowRender: (record) => (
                                            <Row gutter={16} style={{ fontSize: 12 }}>
                                                <Col span={8}>
                                                    🟩 Precios Niños
                                                    <div style={{ fontSize: 12 }}> Niño 1
                                                        <div><b>De </b> {record.preciode1} <b> a </b>{record.precioha1} <b> 1er. Niño </b>{record.precion11} <b> 2do. Niño </b> {record.precion12}</div>
                                                    </div>                                            
                                                    <div style={{ fontSize: 12 }}> Niño 2
                                                        <div><b>De </b> {record.preciode2} <b> a </b>{record.precioha2} <b> 1er. Niño </b>{record.precion21} <b> 2do. Niño </b> {record.precion22}</div>
                                                    </div>                                                                                            
                                                    <div style={{ fontSize: 12 }}> Niño 3
                                                        <div><b>De </b> {record.preciode3} <b> a </b>{record.precioha3} <b> 1er. Niño </b>{record.precion31} <b> 2do. Niño </b> {record.precion32}</div>
                                                    </div>                                                                                            
                                                </Col>

                                                <Col span={8}>
                                                    {renderBlock('🟨 Condiciones', CONDITIONS, record)}
                                                </Col>
                                            </Row>
                                        ),
                                        defaultExpandAllRows: false,
                                        showExpandColumn: true
                                    }}                                    
                                    columns={[
                                        {
                                            title: 'Fechas',
                                            key: 'fechas',
                                            width: 180,
                                            render: (_, record) => (
                                                <div>
                                                    <div style={{ fontSize: '12px' }}>
                                                        <CalendarOutlined /> Desde: {dayjs(record.FechaDesde).format('DD/MM/YYYY')}
                                                    </div>
                                                    <div style={{ fontSize: '12px' }}>
                                                        <CalendarOutlined /> Hasta: {dayjs(record.FechaHasta).format('DD/MM/YYYY')}
                                                    </div>
                                                </div>
                                            ),
                                        },                                      
                                        {
                                            title: 'Precio PC',
                                            dataIndex: 'preciopc',
                                            key: 'preciopc',
                                            // ellipsis: true,
                                            render: (valor) => valor !== null && valor !== undefined ? `${parseFloat(valor).toFixed(2)} €` : '-'
                                        },
                                        {
                                            title: 'Precio MP',
                                            dataIndex: 'preciomp',
                                            key: 'preciomp',
                                            ellipsis: true,                                        
                                            render: (valor) => valor !== null && valor !== undefined ? `${parseFloat(valor).toFixed(2)} €` : '-'
                                        },
                                        {
                                            title: 'Precio HD',
                                            dataIndex: 'preciohd',
                                            key: 'preciohd',
                                            ellipsis: true,                                        
                                            render: (valor) => valor !== null && valor !== undefined ? `${parseFloat(valor).toFixed(2)} €` : '-'
                                        },                                        
                                        {
                                            title: 'Precio AL',
                                            dataIndex: 'precioha',
                                            key: 'precioha',
                                            ellipsis: true,                                        
                                            render: (valor) => valor !== null && valor !== undefined ? `${parseFloat(valor).toFixed(2)} €` : '-'
                                        },                                             
                                        {
                                            title: 'Precio TI',
                                            dataIndex: 'Precioti',
                                            key: 'Precioti',
                                            ellipsis: true,                                        
                                            render: (valor) => valor !== null && valor !== undefined ? `${parseFloat(valor).toFixed(2)} €` : '-'
                                        },                                                                                     
                                    ]}
                                />
                            </Card>
                        ) : contratoSeleccionado && (
                            <Alert
                                message="Sin líneas"
                                description="Este contrato no tiene líneas configuradas."
                                type="warning"
                                showIcon
                            />
                        )}                    
                    </Col>
                )}
                </Row>
            </Card>
            ) : (
            <Card 
                title="Precio Manual" 
                size="small"
                style={{ marginBottom: 24 }}
                extra={
                <Checkbox
                    checked={precioManual.reduccionesPorValorAbsoluto}
                    onChange={(e) => setPrecioManual({
                    ...precioManual,
                    reduccionesPorValorAbsoluto: e.target.checked
                    })}
                >
                    Reducciones por Valor Absoluto
                </Checkbox>
                }
            >
                <Row gutter={[16, 16]}>
                {/* Tipo de IVA */}
                <Col span={24}>
                    <Card size="small" title="Tipo de I.V.A.">
                    <Row gutter={[16, 16]}>
                        <Col span={12}>
                        <Select
                            style={{ width: '100%' }}
                            placeholder="Seleccione tipo de IVA"
                            value={precioManual.codigoIVA}
                            onChange={(value) => setPrecioManual({
                            ...precioManual,
                            codigoIVA: value
                            })}
                        >
                            {tiposIVA.map(tipo => (
                            <Option key={tipo.Codigo} value={tipo.Codigo}>
                                {tipo.Descripcion} ({tipo.Porcentaje}%)
                            </Option>
                            ))}
                        </Select>
                        </Col>
                        <Col span={12}>
                        <Radio.Group 
                            value={precioManual.ivaAplicado}
                            onChange={(e) => setPrecioManual({
                            ...precioManual,
                            ivaAplicado: e.target.value
                            })}
                        >
                            <Radio value="I">IVA Incluido</Radio>
                            <Radio value="D">IVA Desglosado</Radio>
                        </Radio.Group>
                        </Col>
                    </Row>
                    </Card>
                </Col>

                {/* Precios Lineales */}
                <Col span={24}>
                    <Title level={5} style={{ marginBottom: 16, color: '#8B0000' }}>
                    Precio Lineal
                    </Title>
                    <Row gutter={[16, 16]}>
                    <Col span={4}>
                        <div style={{ textAlign: 'center', fontWeight: 'bold', color: '#8B0000' }}>
                        PC
                        </div>
                        <InputNumber
                        style={{ width: '100%' }}
                        value={precioManual.LPEspecial}
                        onChange={(value) => setPrecioManual({
                            ...precioManual,
                            LPEspecial: value
                        })}
                        formatter={value => `€ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        parser={value => value.replace(/€\s?|(,*)/g, '')}
                        />
                    </Col>
                    <Col span={4}>
                        <div style={{ textAlign: 'center', fontWeight: 'bold', color: '#8B0000' }}>
                        MP
                        </div>
                        <InputNumber
                        style={{ width: '100%' }}
                        value={precioManual.LPEspecialMP}
                        onChange={(value) => setPrecioManual({
                            ...precioManual,
                            LPEspecialMP: value
                        })}
                        formatter={value => `€ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        parser={value => value.replace(/€\s?|(,*)/g, '')}
                        />
                    </Col>
                    <Col span={4}>
                        <div style={{ textAlign: 'center', fontWeight: 'bold', color: '#8B0000' }}>
                        HD
                        </div>
                        <InputNumber
                        style={{ width: '100%' }}
                        value={precioManual.LPEspecialAL}
                        onChange={(value) => setPrecioManual({
                            ...precioManual,
                            LPEspecialAL: value
                        })}
                        formatter={value => `€ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        parser={value => value.replace(/€\s?|(,*)/g, '')}
                        />
                    </Col>
                    <Col span={4}>
                        <div style={{ textAlign: 'center', fontWeight: 'bold', color: '#8B0000' }}>
                        AL
                        </div>
                        <InputNumber
                        style={{ width: '100%' }}
                        value={precioManual.LPEspecialHA}
                        onChange={(value) => setPrecioManual({
                            ...precioManual,
                            LPEspecialHA: value
                        })}
                        formatter={value => `€ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        parser={value => value.replace(/€\s?|(,*)/g, '')}
                        />
                    </Col>
                    <Col span={4}>
                        <div style={{ textAlign: 'center', fontWeight: 'bold', color: '#8B0000' }}>
                        TI
                        </div>
                        <InputNumber
                        style={{ width: '100%' }}
                        value={precioManual.PrecioTI}
                        onChange={(value) => setPrecioManual({
                            ...precioManual,
                            PrecioTI: value
                        })}
                        formatter={value => `€ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        parser={value => value.replace(/€\s?|(,*)/g, '')}
                        />
                    </Col>
                    {/* <Col span={4}>
                        <div style={{ textAlign: 'center' }}>
                        <Text type="secondary">Regimen</Text>
                        </div>
                        <InputNumber
                        style={{ width: '100%' }}
                        value={precioManual.pEspRegimen}
                        onChange={(value) => setPrecioManual({
                            ...precioManual,
                            pEspRegimen: value
                        })}
                        formatter={value => `€ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        parser={value => value.replace(/€\s?|(,*)/g, '')}
                        />
                    </Col> */}
                    </Row>
                </Col>

                {/* Suplementos */}
                <Col span={12}>
                    <Card size="small" title="Suplementos">
                    <Row gutter={[16, 16]}>
                        <Col span={12}>
                        <div style={{ marginBottom: 8 }}>Individual</div>
                        <InputNumber
                            style={{ width: '100%' }}
                            value={precioManual.SuplementoIndividual}
                            onChange={(value) => setPrecioManual({
                            ...precioManual,
                            SuplementoIndividual: value
                            })}
                            formatter={value => `€ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            parser={value => value.replace(/€\s?|(,*)/g, '')}
                        />
                        </Col>
                        <Col span={12}>
                        <div style={{ marginBottom: 8 }}>Doble</div>
                        <InputNumber
                            style={{ width: '100%' }}
                            value={precioManual.suplementoDoble}
                            onChange={(value) => setPrecioManual({
                            ...precioManual,
                            suplementoDoble: value
                            })}
                            formatter={value => `€ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            parser={value => value.replace(/€\s?|(,*)/g, '')}
                        />
                        </Col>
                    </Row>
                    </Card>
                </Col>

                {/* Doble Uso Individual */}
                <Col span={12}>
                    <Card size="small" title="Doble Uso Individual">
                    <Row gutter={[16, 16]}>
                        <Col span={12}>
                        <InputNumber
                            style={{ width: '100%' }}
                            value={precioManual.DobleUsoIndividual}
                            onChange={(value) => setPrecioManual({
                            ...precioManual,
                            DobleUsoIndividual: value
                            })}
                            formatter={value => `€ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            parser={value => value.replace(/€\s?|(,*)/g, '')}
                        />
                        </Col>
                        <Col span={12}>
                        <Checkbox
                            checked={precioManual.duiSuplemento}
                            onChange={(e) => setPrecioManual({
                            ...precioManual,
                            duiSuplemento: e.target.checked
                            })}
                        >
                            es Suplemento
                        </Checkbox>
                        </Col>
                    </Row>
                    </Card>
                </Col>

                {/* Reducciones Especiales */}
                <Col span={24}>
                    <Card size="small" title="Reducciones Especiales">
                    <Row gutter={[16, 16]}>
                        <Col span={6}>
                        <div style={{ marginBottom: 8 }}>Adulto</div>
                        <InputNumber
                            style={{ width: '100%' }}
                            value={precioManual.PrecioADE}
                            onChange={(value) => setPrecioManual({
                            ...precioManual,
                            PrecioADE: value
                            })}
                            formatter={value => `€ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            parser={value => value.replace(/€\s?|(,*)/g, '')}
                        />
                        </Col>
                        <Col span={6}>
                        <div style={{ marginBottom: 8 }}>Niño</div>
                        <InputNumber
                            style={{ width: '100%' }}
                            value={precioManual.PrecioNIE}
                            onChange={(value) => setPrecioManual({
                            ...precioManual,
                            PrecioNIE: value
                            })}
                            formatter={value => `€ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            parser={value => value.replace(/€\s?|(,*)/g, '')}
                        />
                        </Col>
                    </Row>
                    </Card>
                </Col>

                {/* Reducciones Adultos */}
                <Col span={12}>
                    <Card size="small" title="Reducciones Adultos">
                    <Row gutter={[16, 16]}>
                        <Col span={12}>
                        <div style={{ marginBottom: 8 }}>1er. Adulto</div>
                        <InputNumber
                            style={{ width: '100%' }}
                            value={precioManual.reduccionAdulto1}
                            onChange={(value) => setPrecioManual({
                            ...precioManual,
                            reduccionAdulto1: value
                            })}
                            formatter={value => `€ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            parser={value => value.replace(/€\s?|(,*)/g, '')}
                        />
                        </Col>
                        <Col span={12}>
                        <div style={{ marginBottom: 8 }}>2do. Adulto</div>
                        <InputNumber
                            style={{ width: '100%' }}
                            value={precioManual.reduccionAdulto2}
                            onChange={(value) => setPrecioManual({
                            ...precioManual,
                            reduccionAdulto2: value
                            })}
                            formatter={value => `€ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            parser={value => value.replace(/€\s?|(,*)/g, '')}
                        />
                        </Col>
                    </Row>
                    </Card>
                </Col>

                {/* Descuentos Niños */}
                <Col span={12}>
                    <Card size="small" title="Descuentos Niños">
                    <Row gutter={[8, 8]}>
                        {precioManual.preciosNinos.map((nino, index) => (
                        <Col span={24} key={index}>
                            <Row gutter={[8, 8]}>
                            <Col span={4}>
                                <div style={{ fontSize: 12 }}>De</div>
                                <InputNumber
                                size="small"
                                style={{ width: '100%' }}
                                value={nino.de}
                                onChange={(value) => handleCambioPrecioNino(index, 'de', value)}
                                min={0}
                                max={18}
                                />
                            </Col>
                            <Col span={4}>
                                <div style={{ fontSize: 12 }}>a</div>
                                <InputNumber
                                size="small"
                                style={{ width: '100%' }}
                                value={nino.a}
                                onChange={(value) => handleCambioPrecioNino(index, 'a', value)}
                                min={0}
                                max={18}
                                />
                            </Col>
                            <Col span={6}>
                                <div style={{ fontSize: 12 }}>1º</div>
                                <InputNumber
                                size="small"
                                style={{ width: '100%' }}
                                value={nino.n1}
                                onChange={(value) => handleCambioPrecioNino(index, 'n1', value)}
                                formatter={value => `€ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                parser={value => value.replace(/€\s?|(,*)/g, '')}
                                />
                            </Col>
                            <Col span={6}>
                                <div style={{ fontSize: 12 }}>2º</div>
                                <InputNumber
                                size="small"
                                style={{ width: '100%' }}
                                value={nino.n2}
                                onChange={(value) => handleCambioPrecioNino(index, 'n2', value)}
                                formatter={value => `€ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                parser={value => value.replace(/€\s?|(,*)/g, '')}
                                />
                            </Col>
                            <Col span={4}>
                                <div style={{ fontSize: 12, color: 'transparent' }}>.</div>
                                <Tag color={index === 0 ? 'blue' : index === 1 ? 'green' : 'orange'}>
                                Niño {index + 1}
                                </Tag>
                            </Col>
                            </Row>
                        </Col>
                        ))}
                    </Row>
                    </Card>
                </Col>

                {/* Precio Desglosado */}
                <Col span={24}>
                    <Checkbox
                    checked={precioManual.precioDesglosado}
                    onChange={(e) => setPrecioManual({
                        ...precioManual,
                        precioDesglosado: e.target.checked
                    })}
                    >
                    Reserva con Precios Desglosados
                    </Checkbox>
                </Col>
                </Row>
            </Card>
            )}

            {/* Botones de acción */}
            <Row gutter={[16, 16]} style={{ marginTop: 24 }}>
            <Col span={24}>
                <Space>
                <Button
                    type="primary"
                    icon={<SaveOutlined />}
                    onClick={handleGuardarPrecios}
                    loading={cargandoPrecios}
                    disabled={tipoPrecio === 'contrato' && !contratoSeleccionado}
                >
                    Guardar Precios
                </Button>
                
                {tipoPrecio === 'manual' && (
                    <>
                    {/* <Button
                        type="default"
                        icon={<ReloadOutlined />}
                        onClick={handleActualizarLineas}
                        loading={cargandoPrecios}
                    >
                        Actualizar Líneas
                    </Button> */}
                    
<Button
  type="default"
  icon={<CalculatorOutlined />}
  onClick={handleCalcularImporteManual}
  loading={cargandoPrecios}
>
  Importe Manual Total Factura
</Button>
                    </>
                )}
                </Space>
            </Col>
            </Row>
        </div>
        </TabPane>
      </Tabs>
      
      {/* Modales */}

      <DistribucionHabitacionesModal
        visible={modalDistribucionVisible}
        onCancel={() => setModalDistribucionVisible(false)}
        numReserva={reserva?.NumReserva}
        onSuccess={(data) => {
          console.log('Guardado exitoso:', data);
          // Actualizar datos si es necesario
        }}
      />


      <DepositosReserva
        numReserva={reserva?.NumReserva}
        nombreCliente={reserva?.Nombre}
        visible={depositosModalVisible}
        onClose={() => setDepositosModalVisible(false)}
        onDepositoCreado={() => {
          // Recargar si es necesario
        }}
      />
      
      <CargosReserva
        numReserva={reserva?.NumReserva}
        Reserva={reserva}
        nombreCliente={reserva?.Nombre}
        visible={cargosModalVisible}
        onClose={() => setCargosModalVisible(false)}
        onCargoCreado={() => {
          // Recargar si es necesario
        }}
      />
      
      {/* Modal de búsqueda */}
      <Modal
        title={`Buscar ${tipoBusqueda === 'agencia' ? 'Agencia' : tipoBusqueda === 'subagencia' ? 'Subagencia' : 'Particular'}`}
        open={modalBusquedaVisible}
        onCancel={() => setModalBusquedaVisible(false)}
        width={800}
        footer={null}
        destroyOnClose={true}
      >
        {/* Contenido del modal de búsqueda */}
        <Space direction="vertical" style={{ width: '100%' }}>
          {/* <Input.Search
            placeholder={`Buscar por código o nombre...`}
            value={filtroBusqueda}
            onChange={(e) => setFiltroBusqueda(e.target.value)}
            onSearch={(value) => buscarDatos(tipoBusqueda, value, 1)}
            style={{ marginBottom: 16 }}
          /> */}

          <Input.Search
            placeholder="Buscar por código o nombre..."
            value={filtroBusqueda}
            // onChange={(e) => {
            //   const value = e.target.value;
            //   setFiltroBusqueda(value);
            //   buscarDatos(tipoBusqueda, value, 1);
            // }}
            // onChange={handleBuscarChange}            
            onChange={handleBuscarLocal}
            style={{ marginBottom: 16 }}
            allowClear
          />          
          
          <Table
            columns={[
              { title: 'Código', dataIndex: 'Codigo', key: 'Codigo', width: 100 },
              { title: 'Nombre', dataIndex: 'Nombre', key: 'Nombre', ellipsis: true },
              { title: 'Teléfono', dataIndex: 'Telefono', key: 'Telefono', width: 120 },
              {
                title: 'Acción',
                key: 'accion',
                width: 80,
                render: (_, record) => (
                  <Button
                    type="primary"
                    size="small"
                    onClick={() => seleccionarElemento(record)}
                  >
                    Seleccionar
                  </Button>
                ),
              },
            ]}
            dataSource={datosFiltrados}
            rowKey="Codigo"
            loading={cargandoBusqueda}
            pagination={paginacionBusqueda}
            onChange={(pagination) => {
              buscarDatos(tipoBusqueda, filtroBusqueda, pagination.current);
            }}
            size="small"
          />
        </Space>
      </Modal>



{/* Modal para seleccionar línea */}
<Modal
  title="Seleccionar Habitación"
  open={modalSeleccionLineaVisible}
  onCancel={() => setModalSeleccionLineaVisible(false)}
  footer={null}
  width={600}
>
  <div style={{ padding: 16 }}>
    <Alert
      message="Hay múltiples habitaciones en la reserva"
      description="Seleccione la habitación para la cual desea aplicar el importe manual total."
      type="info"
      showIcon
      style={{ marginBottom: 16 }}
    />
    
    <List
      dataSource={lineasParaImporteManual}
      renderItem={(item) => (
        <List.Item
          actions={[
            <Button
              type="primary"
              size="small"
              onClick={() => handleSeleccionarLineaImporte(item.linea)}
            >
              Seleccionar
            </Button>
          ]}
        >
          <List.Item.Meta
            title={`Habitación ${item.linea}`}
            description={`${item.nombre || 'Sin nombre'} - ${item.totalHabitaciones} ocupante(s)`}
          />
        </List.Item>
      )}
    />
  </div>
</Modal>

{/* Modal para ingresar importe */}
<Modal
  title="Importe Manual Total Factura"
  open={modalImporteManualVisible}
  onCancel={() => {
    setModalImporteManualVisible(false);
    setImporteManualTotal('');
    setLineaSeleccionadaImporte(null);
  }}
  footer={[
    <Button 
      key="cancel" 
      onClick={() => {
        setModalImporteManualVisible(false);
        setImporteManualTotal('');
        setLineaSeleccionadaImporte(null);
      }}
    >
      Cancelar
    </Button>,
    <Button 
      key="submit" 
      type="primary" 
      loading={cargandoPrecios}
      onClick={handleConfirmarImporteManual}
    >
      Aplicar Importe
    </Button>
  ]}
  width={600}
>
  <div style={{ padding: 16 }}>
    <Alert
      message="Instrucciones"
      description={
        <div>
          <p>Ingrese el importe TOTAL de la factura para esta habitación.</p>
          <p>El sistema calculará automáticamente:</p>
          <ul>
            <li>Restará los cargos existentes</li>
            <li>Dividirá entre los días de estancia</li>
            <li>Aplicará el precio al primer ocupante</li>
          </ul>
        </div>
      }
      type="info"
      showIcon
      style={{ marginBottom: 16 }}
    />
    
    <Form layout="vertical">
      <Form.Item label="Importe Total (€)">
        <InputNumber
          style={{ width: '100%' }}
          value={importeManualTotal}
          onChange={setImporteManualTotal}
          min={0}
          step={1}
          precision={2}
          formatter={value => `€ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
          parser={value => value.replace(/€\s?|(,*)/g, '')}
          size="large"
          autoFocus
        />
      </Form.Item>
      
      {lineaSeleccionadaImporte && (
        <Form.Item label="Habitación Seleccionada">
          <Tag color="blue">Línea {lineaSeleccionadaImporte}</Tag>
        </Form.Item>
      )}
    </Form>
    
    <Alert
      message="Nota"
      description="Este importe se aplicará SOLO al primer ocupante de la habitación seleccionada."
      type="warning"
      showIcon
    />
  </div>
</Modal>


      <Facturacion
        reserva={reservaSeleccionada}
        visible={facturacionModalVisible}
        onClose={() => {
          setFacturacionModalVisible(false);
          setReservaSeleccionada(null);
        }}
      />      


    </PageContainer>
  );
};

export default EditarReserva;